import React from 'react';
import { initializeApp } from 'firebase/app';
import 'firebase/analytics';
import {
  User as AuthUser,
  getAuth,
  onAuthStateChanged,
  isSignInWithEmailLink,
  signInWithEmailLink,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  sendSignInLinkToEmail,
  signOut,
  sendEmailVerification
} from 'firebase/auth';
import {
  getFirestore,
  collection,
  doc,
  setDoc,
  updateDoc,
  connectFirestoreEmulator,
  startAt,
  endAt,
  startAfter,
  getDocs,
  serverTimestamp,
  getDoc,
  DocumentReference,
  CollectionReference,
  query,
  where,
  orderBy,
  limit,
  Timestamp,
} from 'firebase/firestore';
import {
  getFunctions,
  httpsCallable,
  connectFunctionsEmulator,
} from 'firebase/functions';
import {
  getStorage,
  ref as storageRef,
  uploadBytesResumable,
  getDownloadURL,
} from 'firebase/storage';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  NavLink,
  useNavigate,
  Navigate,
  Outlet,
  Link,
  RouteProps,
} from 'react-router-dom';
import {
  LinearProgress,
  Button,
  ButtonGroup,
  TextField,
  MenuItem,
  FormControl,
  FormLabel,
  AppBar,
  Toolbar,
  Radio,
  RadioGroup,
  FormControlLabel,
  Typography,
  Container,
  CssBaseline,
  Box,
  makeStyles,
  Snackbar,
  TableContainer,
  TableHead,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Hidden,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Grid,
  FormGroup,
  Switch as MuiSwitch,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Chip,
  Fab,
  Popover,
  ThemeOptions,
  Avatar,
  Checkbox,
  Backdrop,
  CircularProgress,
} from '@mui/material';
import {
  createTheme,
  ThemeProvider,
  useTheme,
  styled,
  Theme
} from '@mui/material/styles';
import DateFnsUtils from '@date-io/date-fns';
import {
  LocalizationProvider,
  DatePicker,
  
} from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import MuiAlert, { AlertProps } from '@mui/lab/Alert';
import {
  VictoryChart,
  VictoryArea,
  VictoryGroup,
  VictoryPolarAxis,
  VictoryLine,
  VictoryTheme,
  VictoryAxis,
} from 'victory';


//import AccountCircleIcon from '@material-ui/icons/AccountCircle';
// import LocalOfferIcon from '@material-ui/icons/LocalOffer';
// import HomeIcon from '@material-ui/icons/Home';
// import PeopleIcon from '@material-ui/icons/People';
// import AddIcon from '@material-ui/icons/Add';
// import EditIcon from '@material-ui/icons/Edit';
// import DeleteIcon from '@material-ui/icons/Delete';
// import SettingsIcon from '@material-ui/icons/Settings';
// import BusinessIcon from '@material-ui/icons/Business';
// import AssignmentIcon from '@material-ui/icons/Assignment';
// import CompareArrowsIcon from '@material-ui/icons/CompareArrows';
// import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
// import MenuIcon from '@material-ui/icons/Menu';
// import CheckIcon from '@material-ui/icons/Check';
// import CancelIcon from '@material-ui/icons/Cancel';
// import RefreshIcon from '@material-ui/icons/Refresh';
// import PersonIcon from '@material-ui/icons/Person';

import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import HomeIcon from '@mui/icons-material/Home';
import PeopleIcon from '@mui/icons-material/People';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SettingsIcon from '@mui/icons-material/Settings';
import BusinessIcon from '@mui/icons-material/Business';
import AssignmentIcon from '@mui/icons-material/Assignment';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import MenuIcon from '@mui/icons-material/Menu';
import CheckIcon from '@mui/icons-material/Check';
import CancelIcon from '@mui/icons-material/Cancel';
import RefreshIcon from '@mui/icons-material/Refresh';
import PersonIcon from '@mui/icons-material/Person';


import { green } from '@mui/material/colors';

import {
  ReactMediaRecorder,
  useReactMediaRecorder,
} from 'react-media-recorder-2';
import dayjs from 'dayjs';
import { Waypoint } from 'react-waypoint';

import Webcam from 'react-webcam';

import ReactPlayer from 'react-player';

import { register, MediaRecorder as ExtendableMediaRecorder, IMediaRecorder } from "extendable-media-recorder";
import { connect } from 'extendable-media-recorder-wav-encoder';
import { Translate } from '@mui/icons-material';
import shadows from '@mui/material/styles/shadows';
//-- Declares

declare namespace MentalTypes {
  type DataElementKey =
    | 'Aggression'
    | 'Neuroticism'
    | 'Inhibition'
    | 'Self regulation'
    | 'Energy'
    | 'Charm'
    | 'Balance'
    | 'Suspect'
    | 'Tension/Anxiety'
    | 'Stress';
  type TagEditProps = {
    tag?: Tag;
    onClose: (update: boolean) => void;
    open: boolean;
    tags?: Tag[];
  };
  type MemberResultListProps = {
    user?: UserData;
    open: boolean;
    onClose: () => void;
  };
  type MemberEditProps = {
    member?: UserData;
    onClose: (update: boolean) => void;
    open: boolean;
    tags?: Tag[];
  };
  type MemberEditCheckTag = Tag & {
    flag: '' | 'user' | 'admin';
  };
  type ResultListTableProps = {
    user?: UserData;
    isMe: boolean;
  };
  type ResultProps = {
    index: number;
    list: Measurement[];
    userId: string;
    forwardRef?: React.Ref<HTMLDivElement>;
  };
  type ResultModalProps = {
    index: number;
    list?: Measurement[];
    open: boolean;
    onClose: () => void;
    onDelete: (index: number) => void;
    user?: UserData;
    isMe: boolean;
    tags?: Tag[];
  };
  type ResultModalElementProps = {
    list?: Measurement[];
    index: number;
    user?: UserData;
    dataElementCompare?: Measurement;
    isMe: boolean;
    tags?: Tag[];
  };
  type ResultModalEmotionProps = {
    list?: Measurement[];
    index: number;
    dataElementCompare?: Measurement;
  };
  type ResultModalGraphProps = {
    list?: Measurement[];
    index: number;
    dataElementCompare?: Measurement;
  };
  type ResultModalCompareProps = {
    open: boolean;
    onClose: () => void;
    date?: (dayjs.Dayjs | null)[];
    setDate: React.Dispatch<React.SetStateAction<dayjs.Dayjs[] | undefined>>;
    mode?: number;
    setMode?: React.Dispatch<React.SetStateAction<number>>;
  };
  type CameraProps = {
    onClose: () => void;
    open: boolean;
  };
  type MeasurementBase = {
    BMax: number;
    BMin: number;
    CMax: number;
    CMin: number;
    M: number;
    M2:number;
    S: number;
    Vi: number;
  };
  type MeasurementBases = {
    [key in DataElementKey]: MeasurementBase;
  };
  type Measurement = {
    base: MeasurementBases;
    info: {
      M: number;
      S: number;
      bd: string;
      comment: string;
      dt: string;
      dtRange?: string;
      err: number;
      fpsMax: number;
      lang: string;
      name: string;
      vMax: number;
      vMin: number;
      xMax: number;
      xMaxA: number;
    };
    fh: number[];
    createdAt: Timestamp;
    fcmToken: string;
    sec: number;
    alerts: DataElementKey[];
    fileName?: string;
    index?: number;
    userId: string;
    serverId?: string;
    measurementId: string;
    device: {
      deviceId: string;
      osName: string;
      osVersion: string;
    };
    isRead: boolean;
    deleted: boolean;
  };
  type Tag = {
    tagId: string;
    tagName: string;
    companyId: string;
    companyName: string;
    isAdmin?: boolean;
    createdAt: Timestamp;
    updatedAt: Timestamp;
  };
  type Company = {
    companyId: string;
    companyName: string;
    accountLimit: number;
    infoText: string;
    infoTitle: string;
    recSec: number;
    recCountPerDay: number;
    createdAt: Timestamp;
    updatedAt: Timestamp;
    deleted: boolean;
  };
  type CompanyData = Company & {
    tags: Tag[];
    accounts: number;
  };
  type User = {
    userId: string;
    nameFirst: string;
    nameLast: string;
    email: string;
    companyId: string;
    tagIds: string[];
    tagIdsAdmin: string[];
    measurement?: {
      createdAt: Timestamp;
      alerts: DataElementKey[];
    };
    measurementShared?: boolean;
    kiyaku: boolean;
    role: 'admin' | 'user';
    createdAt: Timestamp;
    updatedAt: Timestamp;
    deleted: boolean;
  };
  type UserData = User;
  type State = {
    auth: AuthUser;
    user: UserData;
    email: string;
    toast: {
      message: string | string[];
      open: boolean;
      severity: string;
    };
    page: {
      width: number;
      height: number;
    };
    loader: boolean;
  };
  type Action = {
    type: string;
    payload: any;
  };
  type ChartLabels = {
    id: DataElementKey;
    name: string;
    range: number[];
    text: {
      range: number[];
      text: string;
    }[];
    textForAdmin: {
      range: number[];
      text: string;
    }[];
  };
  type ChartLabelsSorted = {
    id: DataElementKey;
    name: string;
  };
  type ChartLabelGroup = {
    [key in 'Positive' | 'Physiological' | 'Negative']: DataElementKey[];
  };
  type ChartLabelsName = {
    [key in DataElementKey]: string;
  };

  type ChartLabels_mult = {
    id: DataElementKey;
    name: string;
    up: number;
    down: number;
    mag: number;
    range: number[];
  };

  type Advertisement = {
    No: number;
    advertisementId: string;
    dispflg: boolean;
    filenm: string;
    token: string;
    type: string;
    updatedAt: Timestamp;
  };

  type maintenances = {
    dispflg: boolean;
    maintenancesId: string;
    message: string;
    updatedAt: Timestamp;
  };

  type CustomRouteProps = {

    beforeEnter: () => boolean;
    
    redirectPath: string;
  } & RouteProps;

}

const NavLinks = [
  { name: 'トップ', link: '/', icon: HomeIcon, exact: true, always: true, mode: 0 },
  { name: '結果', link: 'results', icon: AssignmentIcon, mode: 1 },
  { name: '企業', link: 'company', icon: BusinessIcon, mode: 2 },
  { name: 'メンバー', link: 'members', icon: PeopleIcon, mode: 3 },
  { name: 'タグ', link: 'tags', icon: LocalOfferIcon, mode: 4 },
];

const NavLinks_mainte = [
  { name: 'トップ', link: 'maintenance', icon: HomeIcon, exact: true, always: true },
  { name: '結果', link: 'maintenance', icon: AssignmentIcon },
  { name: '企業', link: 'maintenance', icon: BusinessIcon },
  { name: 'メンバー', link: 'maintenance', icon: PeopleIcon },
  { name: 'タグ', link: 'maintenance', icon: LocalOfferIcon },
];

const themeValues: ThemeOptions = {
  palette: {
    mode: 'light',
    primary: {
      main: 'rgb(0, 156, 225)',
    },
    secondary: {
      main: 'rgb(208, 25, 124)',
    },
    success: {
      main: green[600],
    },
    error: {
      main: 'rgb(208, 25, 124)',
    },
  },
  components: {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          '&$focused': {
            color: 'rgb(0, 156, 225)',
          },
        }
      },
    },
    MuiInput: {
      styleOverrides:{
        underline: {
          '&:after': {
            borderBottomColor: 'rgb(0, 156, 225)',
          },
        },
      }
    },
  },
};

const Button_font10 = styled(Button)(({theme}) => ({
  fontSize: '0.625rem',
}));

const Button_out = styled(Button)(({theme}) => ({
  color: 'black',
  backgroundColor: 'lightgray',
  '&:hover': {
    backgroundColor: 'silver',
    transform: 'translateY(-1px)',
    'box-shadow' : '1px 2px 0 0 rgba(0,0,0,0.3)'
  },
}));

//BOX*****************************************************************

const Box_font11 = styled(Box)(({theme}) => ({
  fontSize: '0.6875rem',
}));

const Box_font12 = styled(Box)(({theme}) => ({
  fontSize: '0.75rem',
}));

const Box_alertBox = styled(Box)(({theme}) => ({
  padding: theme.spacing(0.5, 1),
  borderStyle: 'solid',
  borderWidth: '0.15rem',
  borderColor: theme.palette.secondary.main,
  borderRadius: theme.spacing(1),
  backgroundColor: theme.palette.mode === 'dark' ? '#333' : '#fff',
}));

const Box_page = styled(Box)(({theme}) => ({
  position: 'relative',
  height: '100%',
}));

const Box_captureUploadCounterContainer = styled(Box)(({theme}) => ({
    position: 'absolute',
    width: '90%',
    top: theme.spacing(1),
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    padding: theme.spacing(1),
}));

const Box_captureUploadCounterBar = styled(Box)(({theme}) => ({
    backgroundColor: '#ccc',
    height: 16,
    borderRadius: 4,
}));

const Box_captureCounterContainer = styled(Box)(({theme}) => ({
    position: 'absolute',
    width: '90%',
    top: theme.spacing(1),
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    padding: theme.spacing(1),
}));

const Box_captureCounterDot = styled(Box)(({theme}) => ({
    width: 16,
    height: 16,
    borderRadius: 8,
    marginLeft: 8,
}));

const Box_captureCounterSec = styled(Box)(({theme}) => ({
    position: 'absolute',
    top: 0,
    right: theme.spacing(2),
    color: '#fff',
}));

const Box_captureGuideContainer = styled(Box)(({theme}) => ({
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
    padding: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
}));

const Box_captureGuidContent = styled(Box)(({theme}) => ({
    width: '80%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
}));

const Box_clickable = styled(Box)(({theme}) => ({
    cursor: 'pointer',
    userSelect: 'none',
}));

const Box_captureFrameContainer = styled(Box)(({theme}) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
}));

const Box_captureFrame = styled(Box)(({theme}) => ({
    width: 320,
    height: '70%',
    borderWidth: 2,
    borderStyle: 'solid',
    backgroundColor: 'rgba(0, 0, 0, 0)',
    borderRadius: 20,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
}));

const Box_captureCountDownContainer = styled(Box)(({theme}) => ({
  width: 96,
  height: 96,
  borderRadius: 48,
  display: 'flex',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  justifyContent: 'center',
  alignItems: 'center',
}));

const Box_captureCountDown = styled(Box)(({theme}) => ({
  fontSize: 48,
  fontWeight: 'bold',
  color: '#ccc',
  textAlign: 'center',
}));

const Box_captureNewsContainer = styled(Box)(({theme}) => ({
  width: '100%',
  height: '100%',
  borderRadius: 20,
  padding: theme.spacing(2),
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
}));

const Box_captureNewsTitleContainer = styled(Box)(({theme}) => ({
  borderBottomWidth: 1,
  borderBottomColor: '#fff',
  paddingBottom: 8,
  alignSelf: 'center',
}));

const Box_captureStartButtonContainer = styled(Box)(({theme}) => ({
  width: '100%',
  display: 'flex',
  position: 'absolute',
  bottom: 10,
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
}));

const Box_containerRoute = styled(Box)(({theme}) => ({
  height: 'calc(100% - 80px)',
}));

//**Box****************************************************************** 

const MenuItem_font11 = styled(MenuItem)(({theme}) => ({
  fontSize: '0.6875rem',
}));

const Dialog_paperLarge = styled(Dialog)(({theme}) => ({
    padding: theme.spacing(2),
    height: '90vh',
}));

const Dialog_dialogPaper = styled(Dialog)(({theme}) => ({
  width: '900',
  height: '900',
}));

const Avatar_resultModalElementAvatar = styled(Avatar)(({theme}) => ({
  width: theme.spacing(24),
  height: theme.spacing(24),
}));

// const TableContainer_resultModalTableContainer = styled(TableContainer)(({theme}) => ({
//   marginTop: theme.spacing(2),
//   component: Paper,
// }));

// const TableContainer_resultTableContainer = styled(TableContainer)(({theme}) => ({
//   marginTop: theme.spacing(2),
//   maxHeight: 'calc(100% - 60px)',
//   component: Paper,
// }));

// const TableContainer_companyTableContainer = styled(TableContainer)(({theme}) => ({
//   maxHeight: 'calc(100% - 20px)',
//   component: Paper,
// }));

// const TableContainer_membersTableContainer = styled(TableContainer)(({theme}) => ({
//   maxHeight: 'calc(100% - 80px)',
//   component: Paper,
// }));

// const TableContainer_tagsTableContainer = styled(TableContainer)(({theme}) => ({
//   maxHeight: 'calc(100% - 20px)',
//   component: Paper,
// }));

// const TableContainer_homeTableContainer = styled(TableContainer)(({theme}) => ({
//   maxHeight: 'calc(100% - 80px)',
//   component: Paper,
// }));

const Table_resultModalTable = styled(Table)(({theme}) => ({
  minWidth: 480,
}));

const Table_resultTable = styled(Table)(({theme}) => ({
  minWidth: 1100,
}));

const Table_companyTable = styled(Table)(({theme}) => ({
  minWidth: 640,
}));

const Table_membersTable = styled(Table)(({theme}) => ({
  minWidth: 640,
}));

const Table_tagsTable = styled(Table)(({theme}) => ({
  minWidth: 640,
}));

const Table_homeTable = styled(Table)(({theme}) => ({
  minWidth: 480,
}));

const TableRow_clickable = styled(TableRow)(({theme}) => ({
  cursor: 'pointer',
  userSelect: 'none',
}));

const TableCell_noWrap = styled(TableCell)(({theme}) => ({
  whiteSpace: 'nowrap',
}));

const Chip_clickable = styled(Chip)(({theme}) => ({
  cursor: 'pointer',
  userSelect: 'none',
}));

const Snackbar_clickable = styled(Snackbar)(({theme}) => ({
  cursor: 'pointer',
  userSelect: 'none',
}));

const Container_container = styled(Container)(({theme}) => ({
  height: '100%',
}));

const AppBar_headerAppBar = styled(AppBar)(({theme}) => ({
  padding: theme.spacing(1, 0),
  backgroundColor: 'rgb(0, 156, 225)'
}));

const Link_headerLogo = styled(Link)(({theme}) => ({
  textDecoration: 'none',
  color: '#fff',
}));

const Link_headerNavLink = styled(Link)(({theme}) => ({
  opacity: 0.5,
    textDecoration: 'none',
    textAlign: 'center',
    padding: theme.spacing(0, 2),
    '&:hover': {
      opacity: 1.0,
    },
    color: '#fff',
}));

const Backdrop_loader = styled(Backdrop)(({theme}) => ({
  zIndex: theme.zIndex.modal + 1,
  color: 'white',
}));

const Grid_Center = styled(Grid)(({theme}) => ({
  alignItems: 'center',
  justify: 'center',
}));

const Grid_Center2 = styled(Grid)(({theme}) => ({
  justify: 'center',
}));

const Grid_Flexend = styled(Grid)(({theme}) => ({
  justify: 'flex-end',
}));

const Box_div = styled(Box)(({theme}) => ({
  opacity: 0.5,
  textDecoration: 'none',
  textAlign: 'center',
  padding: theme.spacing(0, 2),
    '&:hover': {
    opacity: 1.0,
  },
  color: '#fff',
  cursor: 'pointer',
  userSelect: 'none',
}));

const Dialog_test = styled(Dialog)(({theme}) => ({
  width: 1000,
  height: 800,
}));



// const useStyles = makeStyles((theme:Theme) => ({
//   font16: {
//     fontSize: '1rem',
//   },
//   font15: {
//     fontSize: '0.9375rem',
//   },
//   font14: {
//     fontSize: '0.875rem',
//   },
//   font13: {
//     fontSize: '0.8125rem',
//   },
//   font12: {
//     fontSize: '0.75rem',
//   },
//   font11: {
//     fontSize: '0.6875rem',
//   },
//   font10: {
//     fontSize: '0.625rem',
//   },
//   container: {
//     height: '100%',
//   },
//   containerRoute: {
//     height: 'calc(100% - 80px)',
//   },
//   page: {
//     position: 'relative',
//     height: '100%',
//   },
//   clickable: {
//     cursor: 'pointer',
//     userSelect: 'none',
//   },
//   headerAppBar: {
//     padding: theme.spacing(1, 0),
//   },
//   headerLogo: {
//     textDecoration: 'none',
//     color: '#fff',
//   },
//   headerNavLink: {
//     opacity: 0.5,
//     textDecoration: 'none',
//     textAlign: 'center',
//     padding: theme.spacing(0, 2),
//     '&:hover': {
//       opacity: 1.0,
//     },
//     color: '#fff',
//   },
//   headerNavLinkActive: {
//     opacity: 1.0,
//   },
//   drawer: {
//     width: 320,
//   },
//   modal: {
//     position: 'absolute',
//     width: '80%',
//     height: '80%',
//     top: '50%',
//     left: '50%',
//     transform: `translate(-50%, -50%)`,
//     backgroundColor: theme.palette.background.paper,
//   },
//   dialogPaper: {
//     width: '90vw',
//     height: '90vh',
//   },
//   dialogPaperLarge: {
//     padding: theme.spacing(2),
//     height: '90vh',
//   },
//   comparePaper: {
//     position: 'absolute',
//     top: 10,
//     right: 10,
//     padding: theme.spacing(2),
//     textAlign: 'center',
//   },
//   noWrap: {
//     whiteSpace: 'nowrap',
//   },
//   homeTableContainer: {
//     maxHeight: 'calc(100% - 80px)',
//   },
//   homeTable: {
//     minWidth: 480,
//   },
//   resultTableContainer: {
//     marginTop: theme.spacing(2),
//     maxHeight: 'calc(100% - 60px)',
//   },
//   resultTable: {
//     minWidth: 1100,
//   },
//   resultModalTableContainer: {
//     marginTop: theme.spacing(2),
//   },
//   resultModalTable: {
//     minWidth: 480,
//   },
//   companyTableContainer: {
//     maxHeight: 'calc(100% - 20px)',
//   },
//   companyTable: {
//     minWidth: 640,
//   },
//   membersTableContainer: {
//     maxHeight: 'calc(100% - 80px)',
//   },
//   membersTable: {
//     minWidth: 640,
//   },
//   measureTableContainer: {
//     minWidth: 640,
//     maxHeight: '70vh',
//   },
//   tagsTableContainer: {
//     maxHeight: 'calc(100% - 20px)',
//   },
//   tagsTable: {
//     minWidth: 640,
//   },
//   signDialog: {
//     position: 'absolute',
//     top: 0,
//     left: 0,
//   },
//   captureCounterContainer: {
//     position: 'absolute',
//     width: '90%',
//     top: theme.spacing(1),
//     borderRadius: 8,
//     display: 'flex',
//     flexDirection: 'row',
//     justifyContent: 'center',
//     backgroundColor: 'rgba(0, 0, 0, 0.5)',
//     padding: theme.spacing(1),
//   },
//   captureCounterDot: {
//     width: 16,
//     height: 16,
//     borderRadius: 8,
//     marginLeft: 8,
//   },
//   captureCounterSec: {
//     position: 'absolute',
//     top: 0,
//     right: theme.spacing(2),
//     color: '#fff',
//   },
//   captureUploadCounterContainer: {
//     position: 'absolute',
//     width: '90%',
//     top: theme.spacing(1),
//     borderRadius: 8,
//     display: 'flex',
//     flexDirection: 'row',
//     backgroundColor: 'rgba(0, 0, 0, 0.5)',
//     padding: theme.spacing(1),
//   },
//   captureUploadCounterBar: {
//     backgroundColor: '#ccc',
//     height: 16,
//     borderRadius: 4,
//   },
//   captureGuideContainer: {
//     position: 'absolute',
//     width: '100%',
//     height: '100%',
//     top: 0,
//     left: 0,
//     backgroundColor: 'rgba(0, 0, 0, 0.75)',
//     padding: theme.spacing(1),
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//     justifyContent: 'center',
//   },
//   captureGuidContent: {
//     width: '80%',
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//     justifyContent: 'center',
//   },
//   captureFrameContainer: {
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     position: 'absolute',
//     top: 0,
//     left: 0,
//     width: '100%',
//     height: '100%',
//   },
//   captureFrame: {
//     width: 320,
//     height: '70%',
//     borderWidth: 2,
//     borderStyle: 'solid',
//     backgroundColor: 'rgba(0, 0, 0, 0)',
//     borderRadius: 20,
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//   },
//   captureCountDownContainer: {
//     width: 96,
//     height: 96,
//     borderRadius: 48,
//     display: 'flex',
//     backgroundColor: 'rgba(0, 0, 0, 0.5)',
//     justifyContent: 'center',
//     alignItems: 'center',
//   },
//   captureCountDown: {
//     fontSize: 48,
//     fontWeight: 'bold',
//     color: '#ccc',
//     textAlign: 'center',
//   },
//   captureNewsContainer: {
//     width: '100%',
//     height: '100%',
//     borderRadius: 20,
//     padding: theme.spacing(2),
//     backgroundColor: 'rgba(0, 0, 0, 0.5)',
//     display: 'flex',
//     flexDirection: 'column',
//     justifyContent: 'center',
//   },
//   captureNewsTitleContainer: {
//     borderBottomWidth: 1,
//     borderBottomColor: '#fff',
//     paddingBottom: 8,
//     alignSelf: 'center',
//   },
//   captureStartButtonContainer: {
//     width: '100%',
//     display: 'flex',
//     position: 'absolute',
//     bottom: 10,
//     flexDirection: 'row',
//     justifyContent: 'center',
//     alignItems: 'center',
//   },
//   resultModalElementAvatar: {
//     width: theme.spacing(24),
//     height: theme.spacing(24),
//   },
//   alertBox: {
//     padding: theme.spacing(0.5, 1),
//     borderStyle: 'solid',
//     borderWidth: '0.15rem',
//     borderColor: theme.palette.secondary.main,
//     borderRadius: theme.spacing(1),
//     backgroundColor: theme.palette.mode === 'dark' ? '#333' : '#fff',
//   },
//   loader: {
//     zIndex: theme.zIndex.modal + 1,
//     color: 'white',
//   },
// }));

const newsFeed = 'https://am1.sqz.jp/news.php';

const firebaseConfig = process.env.firebase_config ?? {};
const firebaseApp = initializeApp(firebaseConfig);
const firebaseAuth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp);
const functions = getFunctions(firebaseApp, 'asia-northeast2');
if (window.location.hostname === 'localhost') {
  connectFunctionsEmulator(functions, 'localhost', 5001);
  connectFirestoreEmulator(db, 'localhost', 8100);
}
const firebaseStorage = getStorage(firebaseApp);

const initialState = {
  auth: null,
  user: {
    userId: '',
    nameFirst: '',
    nameLast: '',
    email: '',
    tagIds: [],
    tagIdsAdmin: [],
    measurement: {
      createdAt: Timestamp.now(),
      alerts: [],
    },
    kiyaku: false,
    role: 'user',
  },
  toast: {
    message: '',
    open: false,
    severity: '',
  },
  loader: false,
};

const Context = React.createContext(
  {} as {
    state: MentalTypes.State;
    dispatch: React.Dispatch<MentalTypes.Action>;
  }
);

//-- Share Functions

const reducer = (state: MentalTypes.State, action: MentalTypes.Action) => {
  switch (action.type) {
    case 'INIT':
      return action.payload;
    case 'AUTH_UPDATE':
      return { ...state, auth: action.payload };
    case 'USER_UPDATE':
      return { ...state, user: action.payload };
    case 'TOAST_UPDATE':
      return { ...state, toast: action.payload };
    case 'LOADER_UPDATE':
      return { ...state, loader: action.payload };
    default:
      return state;
  }
};

let toastST: ReturnType<typeof setTimeout>;
const showToast = (
  dispatch: React.Dispatch<MentalTypes.Action>,
  message: string | string[],
  duration = 3,
  severity = 'success'
): Promise<string | string[]> => {
  return new Promise((resolve) => {
    dispatch({
      type: 'TOAST_UPDATE',
      payload: {
        message,
        open: true,
        severity,
      },
    });
    clearTimeout(toastST);
    toastST = setTimeout(() => {
      dispatch({
        type: 'TOAST_UPDATE',
        payload: {
          message,
          open: false,
          severity,
        },
      });
      resolve(message);
    }, duration * 1000);
  });
};

const Alert = (props: AlertProps) => (
  <MuiAlert elevation={6} variant="filled" {...props} />
);

const isErrFbFunc = (
  dispatch: React.Dispatch<MentalTypes.Action>,
  res: { status: string; message: string | string[] },
  duration = 3
) => {
  if (!res || res.status !== 'success') {
    showToast(dispatch, res?.message || '通信エラーが発生しました', duration);
    return true;
  }
  return false;
};

const catchLog = (error: Error, label = '???') => {
  console.log(error.message, `-- Error Occurred in ${label}`);
  return undefined;
};

const fbFunc = async (method: string, args: { [key: string]: any } = {}) => {
  const func = httpsCallable(functions, method);
  const res = (await func(args).catch((e) => {
    console.log(e.message);
  })) as any;
  return res ? res.data : null;
};

const getJpTimeStr = (time: string | undefined) => {
  if (time?.length !== 19) {
    return time;
  }
  const timeStrs = time.substr(0, 16).split(/[- :]/);
  return (
    timeStrs[0] +
    '年' +
    timeStrs[1] +
    '月' +
    timeStrs[2] +
    '日' +
    timeStrs[3] +
    '時' +
    timeStrs[4] +
    '分'
  );
};

const isElementAlert = (id: string, value: number) => {
  const chartLabel = chartLabels.find((vv) => {
    return vv.id === id;
  });
  if (!chartLabel) {
    return false;
  }
  return value >= chartLabel.range[0] && value <= chartLabel.range[1]
    ? false
    : true;
};

const calMeasure = (id: string, calvalue: number, value: number) =>{
  const chartLabel = chartLabels_mult.find((vv) => {
    return vv.id === id;
  });
  if (!chartLabel) {
    return 0;
  }

  const multvalue = Math.round(calvalue * chartLabel.mag * 100) / 100; 
  
  const initState = {
    a: multvalue - chartLabel.down,
    b: chartLabel.up - multvalue,

  };

  return value = 50 * initState.a / (initState.a + initState.b) + 25;

}

const setLocalStorageItem = (key: string, value: string) => {
  window.localStorage.setItem(key, value);
};

const getLocalStorageItem = (key: string): string | null => {
  return window.localStorage.getItem(key);
};

let loaderST: ReturnType<typeof setTimeout>;
const setLoading = (
  dispatch: React.Dispatch<MentalTypes.Action>,
  open: boolean
) => {
  clearTimeout(loaderST);
  loaderST = setTimeout(() => {
    dispatch({ type: 'LOADER_UPDATE', payload: open });
  }, 200);
};

// firestore api

const getMeasurementData = async (data: {
  userId?: string;
  compareFrom?: string;
  compareTo?: string;
  after?: string;
  modeCompare: number;
  dataLimit?: number;
}) => {
  const { userId, after, compareFrom, compareTo, modeCompare, dataLimit } =
    data;
  // users.measurementShared ?
  let fsQuery = query(
    collection(db, `users/${userId}/measurement`),
    where('deleted', '==', false),
    orderBy('createdAt', 'desc')
  );
  if (dataLimit && modeCompare !== 2) {
    fsQuery = query(fsQuery, limit(dataLimit));
  }
  if (compareFrom && compareTo) {
    fsQuery = query(
      fsQuery,
      startAt(dayjs(compareTo).toDate()),
      endAt(dayjs(compareFrom).toDate())
    );
  }
  if (after) {
    fsQuery = query(fsQuery, startAfter(dayjs(after).toDate()));
  }
  const measure = await getDocs(fsQuery).then((mQS) => {
    return mQS.docs.map((mQDS) => {
      return mQDS.data() as MentalTypes.Measurement;
    });
  });
  if (modeCompare === 2 && measure.length) {
    for (let i = 1; i < measure.length; i++) {
      for (const v in measure[i].base) {
        const key = v as keyof MentalTypes.MeasurementBases;
        measure[0].base[key].M += measure[i].base[key].M;
      }
      measure[i].fh.forEach((v, i) => {
        measure[0].fh[i] += v;
      });
    }
    for (const v in measure[0].base) {
      const key = v as keyof MentalTypes.MeasurementBases;
      measure[0].base[key].M =
        Math.floor((measure[0].base[key].M * 10) / measure.length) / 10;
    }
    measure[0].fh.forEach((v, i) => {
      measure[0].fh[i] = Math.floor((v * 100) / measure.length) / 100;
    });
    measure[0].info.dtRange =
      dayjs(measure.slice(-1)[0].info.dt).format('MM-DD') +
      ' - ' +
      dayjs(measure[0].info.dt).format('MM-DD');
    measure.splice(1);
  }
  return measure;
};

const getUser = async (
  userId: string
): Promise<MentalTypes.User | undefined> => {
  const userData = await getDoc(
    doc(db, `users/${userId}`) as DocumentReference<MentalTypes.User>
  )
    .then((userDS) => userDS.data())
    .catch((e) => catchLog(e, 'getUser'));
  if (userData?.deleted === true) {
    return undefined;
  }
  return userData;
};

const getUserData = async (
  dispatch: React.Dispatch<MentalTypes.Action>,
  userId: string
) => {
  return getUser(userId).then((userData) => {
    if (!userData) {
      showToast(dispatch, 'ユーザーデータの取得に失敗しました').then(() => {
        signOut(firebaseAuth);
        location.href = '/';
      });
      return;
    }
    if (!userData.companyId) {
      getTags(userData.tagIds, userData.tagIds).then((tags) => {
        const companyId = tags?.filter((tag) => tag.tagName === '企業')[0]
          .companyId;
        dispatch({ type: 'USER_UPDATE', payload: { ...userData, companyId } });
      });
    } else {
      dispatch({ type: 'USER_UPDATE', payload: { ...userData } });
    }
  });
};

const getTags = async (
  tagIdsAdmin: string[],
  tagIds: string[]
): Promise<MentalTypes.Tag[] | undefined> => {
  const tagIdsMatch = Array.from(
    new Set(
      [...tagIdsAdmin, ...tagIds].filter(
        (tagId) => tagIdsAdmin.includes(tagId) && tagIds.includes(tagId)
      )
    )
  );
  if (tagIdsMatch.length === 0) {
    return undefined;
  }
  const ps = tagIdsMatch.map((tagId) =>
    getDoc(doc(db, `tags/${tagId}`) as DocumentReference<MentalTypes.Tag>)
      .then((tagDS) => tagDS.data())
      .catch((e) => catchLog(e, 'getTags'))
  );
  const tagsData = await Promise.all(ps);
  return tagsData.filter(Boolean) as MentalTypes.Tag[];
};

const getCompaniesData = async (): Promise<
  MentalTypes.CompanyData[] | undefined
> => {
  const comsData = await getDocs(
    query(
      collection(db, 'company') as CollectionReference<MentalTypes.CompanyData>,
      where('deleted', '==', false)
    )
  )
    .then((comQDS) => comQDS.docs.map((comDS) => comDS.data()))
    .catch((e) => catchLog(e, 'getCompanyData'));
  if (!comsData) {
    return undefined;
  }
  const ps = comsData.map(async (comData) => {
    return getDocs(
      query(
        collection(db, 'tags') as CollectionReference<MentalTypes.Tag>,
        where('companyId', '==', comData.companyId)
      )
    ).then((tagQS) => tagQS.docs.map((tagQDS) => tagQDS.data()));
  });
  if (comsData) {
    const comTagIds: string[] = [];
    await Promise.all(ps).then((resArray) =>
      resArray.forEach((tags, index) => {
        comsData[index].tags = tags;
        comTagIds.push(tags.find((tag) => tag.tagName === '企業')?.tagId ?? '');
      })
    );
    const psAccounts: Promise<number>[] = comTagIds.map((comTagId) =>
      getDocs(
        query(
          collection(db, 'users') as CollectionReference<MentalTypes.User>,
          where('tagIds', 'array-contains', comTagId),
          where('deleted', '==', false)
        )
      ).then((usQS) => usQS.size)
    );
    await Promise.all(psAccounts).then((resArray) =>
      resArray.forEach(
        (accounts, index) => (comsData[index].accounts = accounts)
      )
    );
  }
  return comsData;
};

const getMembersData = async (
  tagIdsAdmin: string[],
  days: number
): Promise<MentalTypes.UserData[] | undefined> => {
  const members = await getDocs(
    query(
      collection(db, 'users') as CollectionReference<MentalTypes.UserData>,
      where('tagIds', 'array-contains-any', tagIdsAdmin),
      where('deleted', '==', false),
      orderBy('updatedAt', 'desc')
    )
  )
    .then((memQS) => memQS.docs.map((memQDS) => memQDS.data()))
    .catch((error) => {
      console.log(error.message, 'getMembersData Error');
      return undefined;
    });
  if (days > 0 && members) {
    const endDate = new Date(
      dayjs()
        .add(0 - days, 'days')
        .toDate()
    );
    const ps = members.map((member) =>
      getDocs(
        query(
          collection(
            db,
            `users/${member.userId}/measurement`
          ) as CollectionReference<MentalTypes.Measurement>,
          where('deleted', '==', false),
          orderBy('createdAt', 'desc'),
          endAt(endDate)
        )
      )
        .then((msQS) => msQS.docs.map((msQDS) => msQDS.data()))
        .catch((e) => catchLog(e, 'getMeasurement Collection'))
    );
    await Promise.all(ps).then((resMembers) =>
      resMembers.forEach((resMs, index) => {
        const member = members[index];
        delete member.measurement;
        if (!resMs?.length) {
          return;
        }
        if (member.measurementShared === false) {
          return;
        }
        const measurement = resMs?.reduce<{
          alerts: MentalTypes.DataElementKey[];
          createdAt: Timestamp;
        }>(
          (acc, cur) => {
            return {
              alerts: Array.from(new Set([...acc.alerts, ...cur.alerts])),
              createdAt:
                acc.createdAt.toMillis() < cur.createdAt.toMillis()
                  ? cur.createdAt
                  : acc.createdAt,
            };
          },
          {
            alerts: [],
            createdAt: Timestamp.fromDate(
              dayjs()
                .add(-365 * 10, 'days')
                .toDate()
            ),
          }
        );
        member.measurement = measurement;
      })
    );
  }
  return members;
};

const getCompany = async (
  companyId: string
): Promise<MentalTypes.Company | undefined> => {
  const company = await getDoc(
    doc(db, `company/${companyId}`) as DocumentReference<MentalTypes.Company>
  )
    .then((comDS) => comDS.data())
    .catch((e) => catchLog(e, 'getCompany'));
  return company;
};

const getAdvertisement = async (
  ): Promise<MentalTypes.Advertisement[] | undefined> => {
    const advertisement = await getDocs(
        query(
          collection(
            db,
            `advertisement`
          ) as CollectionReference<MentalTypes.Advertisement>,
          where('dispflg', '==', true),
          orderBy('updatedAt', 'desc')
        )
      )
      .then((msQS) => msQS.docs.map((msQDS) => msQDS.data()))
      .catch((error) => {
        console.log(error.message, 'getAdvertisement Error');
        return undefined;
      });
      return advertisement;
  };

  const updAdvertisement = async (
    advertisementId: string
  ): Promise<boolean> => {
    const updateflg = await 
    updateDoc(doc(db, `advertisement/${advertisementId}`),{
      updatedAt: serverTimestamp(),
    });
    return true;
  };

  const getMaintenance = async (
  ): Promise<MentalTypes.maintenances[] | undefined> => {
    const maintenances = await getDocs(
        query(
          collection(
            db,
            `maintenances`
          ) as CollectionReference<MentalTypes.maintenances>,
          where('dispflg', '==', true),
          orderBy('updatedAt', 'desc')
        )
      )
      .then((msQS) => msQS.docs.map((msQDS) => msQDS.data()))
      .catch((error) => {
        console.log(error.message, 'getMaintenance Error');
        return undefined;
      });
      return maintenances;
  };

//-- Components

const Loading = () => {
  return <LinearProgress />;
};

const ConfirmDialog = ({
  onOk,
  onCancel,
  title,
  message,
  okButton,
  cancelButton,
}: {
  onOk: () => void;
  onCancel: () => void;
  title: string;
  message: React.ReactNode;
  okButton?: string;
  cancelButton?: string;
}) => {
  return (
    <Dialog open={true}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{message}</DialogContent>
      <DialogActions
        style={{ marginRight: '1.0rem'}}
      >
        <Button onClick={onOk} color="primary">
          {okButton ?? '決定'}
        </Button>
        <Button onClick={onCancel} color="secondary">
          {cancelButton ?? 'キャンセル'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const Maintenance = () => {
  return (
    <Box_page>
      <p>メンテナンス中です。</p>
    </Box_page>
  );
}

const SignInView = ({
  onClose,
  open,
  anchorEl,
}: {
  onClose: () => void;
  open: boolean;
  anchorEl: HTMLDivElement | null;
}) => {

  const { dispatch } = React.useContext(Context);
  const [email, setEmail] = React.useState('');
  const [pass, setPass] = React.useState('');
  const [mode, setMode] = React.useState<'pass' | 'email'>('email');
  const inputRef = React.useRef<HTMLInputElement | null>(null);
  const onLogin = async () => {
    setLoading(dispatch, true);
    const existsRes = await fbFunc('existsAuthUser', { email }).catch(
      () => null
    );
    if (existsRes?.exists !== true) {
      setLoading(dispatch, false);
      showToast(dispatch, `${email} は登録されていません`);
      return;
    }
    if (mode === 'email') {
      sendSignInLinkToEmail(firebaseAuth, email, {
        url: window.location.origin,
        handleCodeInApp: true,
      })
        .then(() => {
          setLocalStorageItem('emailForSignIn', email);
          onClose();
          showToast(
            dispatch,
            '認証用のメールを送信しました。記載のリンクをタップしてログインしてください。このウインドウは閉じて問題ありません。',
            30
          );
        })
        .catch((e) => {
          showToast(dispatch, e.message, 30);
          console.log(e.message);
        })
        .finally(() => {
          setLoading(dispatch, false);
        });
    } else {
      signInWithEmailAndPassword(firebaseAuth, email, pass)
        .then(() => {
          onClose();
          // showToast(dispatch, 'ログインしました').then(() => {
          //   history.replaceState('', '', '/');
          // });
        })
        .catch((e) => {
          showToast(dispatch, e.message, 30);
          console.log(e.message);
        })
        .finally(() => {
          setLoading(dispatch, false);
        });
    }
  };
  const modeToggle = () => {
    setMode(mode === 'email' ? 'pass' : 'email');
    setTimeout(() => {
      inputRef.current?.focus();
    }, 250);
  };
  const onKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter') {
      onLogin();
    }
  };
  return (
    <Popover
      open={open}
      onClose={onClose}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <Box m={1} display="flex" flexDirection="column">
        <TextField
          inputRef={inputRef}
          autoFocus　
          fullWidth
          type="text"
          label="メールアドレス"
          onChange={(e) => {
            setEmail(e.target.value);
          }}
          margin="dense"
          onKeyDown={onKeyDown}
        />
        <TextField
          type="password"
          label="パスワード"
          onChange={(e) => {
            setPass(e.target.value);
          }}
          style={{
            display: mode === 'email' ? 'none' : 'inline',
          }}
          margin="dense"
          onKeyDown={onKeyDown}
        />
      </Box>
      <Box m={1}>
        <Button variant="contained" color="primary" onClick={onLogin}>
          ログイン
        </Button>
        <Button_font10 onClick={modeToggle}>
          {mode === 'pass' ? 'メールでログイン' : 'パスワードでログイン'}
        </Button_font10>
      </Box>
    </Popover>
  );
};

const SignOutView = ({
  onClose,
  open,
  anchorEl,
}: {
  onClose: () => void;
  open: boolean;
  anchorEl: HTMLDivElement | null;
}) => {
  
  const navigate = useNavigate();
  const { dispatch, state } = React.useContext(Context);
  const { user } = state;
  const [comTags, setComTags] = React.useState<MentalTypes.Tag[] | undefined>();
  const [showComSelect, setShowComSelect] = React.useState(false);
  const [companyId, setCompanyId] = React.useState('');
  React.useEffect(() => {
    if (user?.tagIds.length) {
      getTags(user.tagIds, user.tagIds).then((tags) => {
        const comTags_ = tags?.filter((tag) => tag.tagName === '企業');
        setComTags(comTags_);
        setCompanyId(user?.companyId ?? comTags_?.[0].companyId);
      });
    }
  }, [user?.tagIds]);
  const onPressSignOut = () => {
    signOut(firebaseAuth)
      .then(() => {
        showToast(dispatch, 'ログアウトしました').then(() => {
          navigate('/');
        });
      })
      .catch((error) => {
        console.log(error, 'error');
      });
    onClose();
  };
  const onPressPasswordReset = () => {
    sendPasswordResetEmail(firebaseAuth, user.email).then(() => {
      onClose();
      showToast(dispatch, 'パスワード設定用のメールを送信しました');
    });
  };
  const onChangeCompanyId = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    const tag = comTags?.find((comTag) => comTag.companyId === e.target.value);
    if (tag) {
      updateDoc(doc(db, `users/${user?.userId}`), {
        companyId: tag.companyId,
        updatedAt: serverTimestamp(),
      }).then(() => {
        setCompanyId(e.target.value);
        dispatch({
          type: 'USER_UPDATE',
          payload: { ...user, companyId: e.target.value },
        });
        showToast(
          dispatch,
          `デフォルト企業を「${tag.companyName}」に設定しました`
        );
      });
    }
  };
  return (
    <Popover
      open={open}
      onClose={onClose}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <Box m={1} display="flex" flexDirection="column">
        {!showComSelect && (
          <>
            <Button onClick={onPressSignOut}>
              <Box_font11>ログアウトする</Box_font11>
            </Button>
            <Button onClick={onPressPasswordReset}>
              <Box_font11>パスワードを設定</Box_font11>
            </Button>
          </>
        )}
        {(comTags?.length ?? 0) > 1 && (
          <Button onClick={() => setShowComSelect(true)}>
            <Box_font11>デフォルト企業の設定</Box_font11>
          </Button>
        )}
        {showComSelect && (
          <Box>
            <TextField
              select
              name="company"
              value={companyId}
              onChange={onChangeCompanyId}
              style={{ width: '12.0rem' }}
              InputProps={{
                style: {
                  fontSize: '0.75rem',
                },
              }}
            >
              {comTags?.map((v) => (
                <MenuItem_font11
                  key={v.companyId}
                  value={v.companyId}

                >
                  {v.companyName}
                </MenuItem_font11>
              ))}
            </TextField>
          </Box>
        )}
      </Box>
    </Popover>
  );
};

const MemberResultList = ({
  user,
  open,
  onClose,
}: MentalTypes.MemberResultListProps) => {

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth={false}
      PaperProps={{ sx: { maxWidth: "revert", width: 1280 } }}
    >
      <DialogContent>
        <ResultListTable user={user} isMe={false} />
      </DialogContent>
    </Dialog>
  );
};

const VideoPreview = ({ stream }: { stream: MediaStream | null }) => {
  const videoRef = React.useRef<HTMLVideoElement>(null);
  React.useEffect(() => {
    if (videoRef.current && stream) {
      videoRef.current.srcObject = stream;
    }
  }, [stream]);
  if (!stream) {
    return null;
  }
  return (
    <video
      style={{
        transform: 'rotateY(180deg)',
      }}
      ref={videoRef}
      width="900"
      height="675"
      autoPlay
    />
  );
};

const SetPreview = ({ stream }: { stream: MediaStream | null }) => {
  const [videoTest, setVideoTest] = React.useState<HTMLVideoElement | null>();
  React.useEffect(() => {
    if(videoTest && stream) {
      videoTest.srcObject = stream;
    }
  }, [stream]);
  if (!stream) {
    return null;
  }
  return (
    <video
      style={{
        transform: 'rotateY(180deg)',
      }}
      ref={elm => { // コールバック関数を与える
        setVideoTest(elm);
      }}
      width="1000"
      height="750"
      autoPlay
    />
  );

};

const UploadCounter = ({ counter, max }: { counter: number; max: number }) => {
  
  return (
    <Box_captureUploadCounterContainer>
      {Boolean(counter && max) && (
        <Box_captureUploadCounterBar
          width={(counter / max) * 100 + '%'}

        />
      )}
    </Box_captureUploadCounterContainer>
  );
};

const SecPerCircle = 5;
const CaptureCounter = ({ counter, max }: { counter: number; max: number }) => {

  return (
    <Box_captureCounterContainer>
      {[...Array(max / SecPerCircle)].map((_v: any, i) => (
        <Box_captureCounterDot
          key={i}
          bgcolor={counter / SecPerCircle >= i + 1 ? '#aaa' : '#fff'}
        />
      ))}
      <Box_captureCounterSec>
        <Typography variant="h6">{`${max - counter}s`}</Typography>
      </Box_captureCounterSec>
    </Box_captureCounterContainer>
  );
};

const CaptureGuide = ({ onClick }: { onClick: () => void }) => {
  
  return (
    <Box_captureGuideContainer>
      <Box_captureGuidContent>
        <Typography color={'white'}>
          {'撮影は出来るだけ明るい場所で、白い壁を背景に行ってください'}
        </Typography>
        <Typography color={'white'}>
          {'顔の輪郭が白い線一杯になるまで近づけてください'}
        </Typography>
        <Box_clickable
          mt={2}
          borderBottom="0.1rem solid #ccc"
          onClick={onClick}
        >
          <Typography color={'white'}>{'OK'}</Typography>
        </Box_clickable>
      </Box_captureGuidContent>
    </Box_captureGuideContainer>
  );
};

const CountDownMax = 3;
const CountUpMaxDefault = 60;
const newsNumPerPage = 3;
const CameraModal = ({ onClose, open }: MentalTypes.CameraProps) => {
  const { state, dispatch } = React.useContext(Context);
  const { user } = state;
  const { startRecording, stopRecording, mediaBlobUrl, previewStream } =
    useReactMediaRecorder({ video: true, audio: false });

  const uploadVideo = React.useRef(false);
  const [mode, setMode] = React.useState(0);
  const counterTO = React.useRef<ReturnType<typeof setTimeout> | null>(null);
  const [counter, setCounter] = React.useState(0);
  const [countUpMax, setCountUpMax] = React.useState(CountUpMaxDefault);
  const [progress, setProgress] = React.useState<any>(null);
  const [isGuide, setIsGuide] = React.useState(true);
  const [news, setNews] = React.useState<string[]>([]);
  const [newsTitle, setNewsTitle] = React.useState('');
  const divRef = React.useRef<HTMLDivElement>(null);
  let newsPos = Math.floor(counter / 5) * newsNumPerPage;
  if (news.length <= newsPos) {
    newsPos = 0;
  }

  const [onPreview, setOnPreview] = React.useState(false);
  
  React.useEffect(() => {
    getCompany(user.companyId).then((res) => {
      setNewsTitle(res?.infoTitle || '');
      setCountUpMax(res?.recSec || CountUpMaxDefault);
      if (res?.infoText.length) {
        setNews(res.infoText.split('\n'));
      } else {
        fetch(newsFeed).then((res) => {
          res.text().then((text) => {
            const news_ = text.match(/<title>(.+?)<\/title>/g)?.map((v) => {
              return v.replace(/(<([^>]+)>)/gi, '');
            });
            if (news_?.length) {
              setNews(news_.slice(1));
            }
          });
        });
      }
    });
  }, []);
  React.useEffect(() => {
    return () => {
      if (counterTO.current) {
        clearTimeout(counterTO.current);
      }
      stopRecording();
      location.reload();
    };
  }, []);
  React.useEffect(() => {
    setCounter(0);
  }, [mode]);
  React.useEffect(() => {
    if (mode === 1 || mode === 2) {
      counterTO.current = setTimeout(() => {
        if (mode === 1 && counter === CountDownMax) {
          setMode(2);
          setOnPreview(true);
          startRecording();
        } else if (mode === 2 && counter === countUpMax) {
          uploadVideo.current = true;
          stopRecording();
          setMode(3);
        } else {
          setCounter(counter + 1);
        }
      }, 1000);
    }
    return () => {
      if (counterTO.current) {
        clearTimeout(counterTO.current);
      }
    };
  }, [mode, counter]);
  React.useEffect(() => {
    if (mediaBlobUrl && user?.userId && uploadVideo.current) {
      fetch(mediaBlobUrl)
        .then((res) => {
          return res.blob();
        })
        .then(async (blob) => {
          const measureDR = doc(
            collection(doc(collection(db, 'users'), user.userId), 'measurement')
          );
          setDoc(measureDR, {
            measurementId: measureDR.id,
            userId: user.userId,
            sec: countUpMax,
          });
          try {
            const fn = 'video/new/' + measureDR.id + '.mp4';
            const task = uploadBytesResumable(
              storageRef(firebaseStorage, fn),
              blob
            );
            task.on('state_changed', (taskSnapshot: any) => {
              setProgress(taskSnapshot);
            });
            task.then(() => {
              showToast(dispatch, 'データを送信しました。結果をお待ちください');
              setTimeout(onClose, 3000);
            });
          } catch (e:any) {
            showToast(dispatch, e.message);
          }
        });
    }
  }, [mediaBlobUrl]);
  const onPressCapture = () => {
    if (mode === 3) {
      return;
    }
    if (mode === 0) {
      setMode(1);
    } else {
      setMode(0);
      try {
        stopRecording();
      } catch (e:any) {
        console.log(e.message);
      }
      location.reload();
    }
  };
  const renderVideoPreview = React.useMemo(
    () => <VideoPreview stream={previewStream} />,
    [!!previewStream]
  );


  // const [fileNm, setfileNm] = React.useState<
  //     MentalTypes.Advertisement[] | undefined
  // >();

  // const advertisementId = "uT9xgX781HGxNPx24FTS";

  
  // React.useEffect(() => {
  //   getAdvertisement().then((res) => {
  //     setfileNm(res);
  //   });
    
  // }, []);

  return (
    <div ref={divRef}>
      <Dialog
        open={open}
        onClose={onClose}
        fullWidth
        maxWidth={false}
        PaperProps={{ sx: { maxWidth: "revert", width: 960, height: 720 } }}
      >
        {onPreview === false ? (
          <Webcam 
          mirrored 
          width="960"
          height="720">
          </Webcam>
        ):null}
        <ReactMediaRecorder
          video
          mediaRecorderOptions={{ videoBitsPerSecond: 1000 * 1000 }}
          render={() => renderVideoPreview}
        />
        <Box_captureFrameContainer>
          <Box_captureFrame
            borderColor={mode === 2 ? 'red' : '#ccc'}
          >
            {mode === 1 ? (
              <Box_captureCountDownContainer>
                <Box_captureCountDown>{3 - counter}</Box_captureCountDown>
              </Box_captureCountDownContainer>
            ) : null}
            {mode === 2 && news.length ? (
              <Box_captureNewsContainer>
                <Box_captureNewsTitleContainer>
                  <Typography variant="h6" color={'white'}>{newsTitle}</Typography>
                </Box_captureNewsTitleContainer>
                {news.slice(newsPos, newsPos + 3).map((v, i) => (
                  <Box key={i} display="flex" mt={i === 0 ? 2 : 1}>
                    <Typography color={'white'}>{'●'}</Typography>
                    <Box ml={1}>
                      <Typography color={'white'}>{v}</Typography>
                    </Box>
                  </Box>
                ))}
              </Box_captureNewsContainer>
            ) : null}
            {mode === 3 && (
              <Box borderRadius={8} bgcolor="rgba(0, 0, 0, 0.5)" p={2}>
                <Typography variant="h5" color={'white'}>{'お疲れさまでした！'}</Typography>
              </Box>
            )}
          </Box_captureFrame>
          <Box_captureStartButtonContainer>
            <Box_clickable
              bgcolor="rgba(0, 0, 0, 0.5)"
              borderRadius={8}
              onClick={onPressCapture}
              color={mode === 3 ? '#333' : '#aaa'}
              px={4}
              py={2}
            >
              <Typography variant="h5">
                {mode === 0 ? '録画開始' : '録画を中断'}
              </Typography>
            </Box_clickable>
          </Box_captureStartButtonContainer>
          {mode === 3 && progress ? (
            <UploadCounter
              counter={progress?.bytesTransferred || 0}
              max={progress?.totalBytes || 0}
            />
          ) : (
            <CaptureCounter
              counter={mode === 2 ? counter : 0}
              max={countUpMax}
            />
          )}
        </Box_captureFrameContainer>
        {isGuide ? <CaptureGuide onClick={() => setIsGuide(false)} /> : null}
      </Dialog>
    </div>
  );
};

const chartLabelsName: MentalTypes.ChartLabelsName = {
  Aggression: '攻撃性',
  Stress: 'ストレス',
  'Tension/Anxiety': '緊張',
  Suspect: '疑心',
  Balance: '安定性',
  Charm: '魅力',
  Energy: '活力',
  'Self regulation': '自制心',
  Inhibition: '抑圧',
  Neuroticism: '神経質',
};

const chartLabels: MentalTypes.ChartLabels[] = [
  {
    id: 'Aggression',
    name: '攻撃性',
    range: [20, 50],
    text: [
      { range: [0, 20], text: '感情的な消耗、受動的な状態' },
      { range: [21, 50], text: '受動的で防御的だが、攻撃的側面を含む' },
      {
        range: [51, 100],
        text: '感情的に疲弊。数値が増えるほど防御的要素よりも攻撃的な態度が増している状態',
      },
    ],
    textForAdmin: [
      {
        range: [0, 20],
        text: '受動的で防御意識が高く、他者に対して危害を加える可能性がかなり低い状態といえます。逆に言えば向かっていく気持ちが低く、交渉事などには向かない状態ともいえます',
      },
      {
        range: [21, 50],
        text: '受動的・攻撃的バランスが安定しており、良好な状態といえます。ただし、攻撃的な要素については若干その可能性を含んでいますので配慮して指導をお願い致します',
      },
      {
        range: [51, 100],
        text: '疲れ弱っており、その原因を他者へと向ける傾向の状態といえます。また防御的要素よりも攻撃的要素が高く、数値が増えるほど攻撃的な態度となって表面化していきます。注意して指導をお願い致します',
      },
    ],
  },
  {
    id: 'Neuroticism',
    name: '神経質',
    range: [10, 50],
    text: [
      { range: [0, 10], text: '無気力、精神的変動性が低い状態' },
      {
        range: [11, 30],
        text: '精神的変動性は安定している、複雑度の低いルーティンワークなどで見られる状態',
      },
      {
        range: [31, 50],
        text: '精神的変動性は平均の範囲内。複雑度の高いタスクを解決する際に見られてる状態',
      },
      {
        range: [51, 100],
        text: '精神的変動性が高く、興奮している時やオーバーワーク状態、受験等の際に見られる状態',
      },
    ],
    textForAdmin: [
      {
        range: [0, 10],
        text: '抑圧レベルの測定値のばらつきを示します。神経質（不安や恐怖、怒りっぽさ、嫉妬、孤独感）を特性とした感情レベルのばらつきがない状態といえます。感情の起伏が少ないといえますが、逆に喜怒哀楽がはっきりしないともいえます',
      },
      {
        range: [11, 30],
        text: '抑圧レベルの測定値のばらつきを示します。神経質（不安や恐怖、怒りっぽさ、嫉妬、孤独感）を特性とした感情レベルのばらつきが比較的少ない状態といえます。複雑度の低いルーティンワークなどで見られる状態です',
      },
      {
        range: [31, 50],
        text: '抑圧レベルの測定値のばらつきを示します。神経質（不安や恐怖、怒りっぽさ、嫉妬、孤独感）を特性とした感情レベルのばらつきが比較的高い状態といえます。複雑度の高いタスク（仕事・作業）などで見られる状態です',
      },
      {
        range: [51, 100],
        text: '抑圧レベルの測定値のばらつきを示します。神経質（不安や恐怖、怒りっぽさ、嫉妬、孤独感）を特性とした感情レベルのばらつきが非常に高い状態といえます。興奮している時やオーバーワーク状態、受験等の際に見られる状態といえます',
      },
    ],
  },
  {
    id: 'Inhibition',
    name: '抑圧',
    range: [10, 25],
    text: [
      { range: [0, 12], text: '刺激に対し素早い反応' },
      { range: [13, 20], text: '平常の反応' },
      { range: [21, 100], text: '反応が遅い状態' },
    ],
    textForAdmin: [
      {
        range: [0, 12],
        text: '強い刺激に対する生体（生きているままの身体）の反応を表します。反応の機敏性（刺激に対しての反応時間）を示します。数値が低い場合、抑圧（欲望・行動などをおさえつける）レベルは低いといえます',
      },
      {
        range: [13, 20],
        text: '強い刺激に対する生体（生きているままの身体）の反応を表します。反応の機敏性（刺激に対しての反応時間）を示します。数値は標準的で、抑圧（欲望・行動などをおさえつける）レベルは中程度といえます',
      },
      {
        range: [21, 100],
        text: '強い刺激に対する生体（生きているままの身体）の反応を表します。反応の機敏性（刺激に対しての反応時間）を示します。数値は標準より高く他の人から抑圧を受け、自分自身を抑制しているレベルといえます',
      },
    ],
  },
  {
    id: 'Self regulation',
    name: '自制心',
    range: [50, 100],
    text: [
      {
        range: [0, 100],
        text: 'ポジティブに属する安定性・魅力・活力の総合評価',
      },
    ],
    textForAdmin: [
      {
        range: [0, 100],
        text: '上記の安定性・魅力・活力の3要素から総合的に評価される数値となります。ポジティブな感情による潜在的レベルを表します。数値が高くなれば、前向きで積極的・行動的で「どんな事でもきっと良い方向に物事が向かっていくだろう」と思える傾向の高い状態といえます。また自分自身の人生や活動に確信がある状態です',
      },
    ],
  },
  {
    id: 'Energy',
    name: '活力',
    range: [10, 50],
    text: [
      { range: [0, 15], text: '睡眠、受動的状態' },
      {
        range: [16, 50],
        text: '習慣的な活動。数値が上がるほど複雑な問題を解決しようとする標準的な状態',
      },
      {
        range: [51, 100],
        text: '精神的、身体的適応に関して条件的に不可能なタスクを解決しようとする状態',
      },
    ],
    textForAdmin: [
      {
        range: [0, 15],
        text: '物ごとを成し遂げる気力に欠けている状態といえます。体内に保持するエネルギー（馬力）が弱い状態であるともいえます',
      },
      {
        range: [16, 50],
        text: '一般的（平均的）な活力の状態といえます。標準的エネルギー（馬力）は有しており習慣的なタスク（仕事や作業）では成果が認められるといえます',
      },
      {
        range: [51, 100],
        text: '精神的・肉体的に体内エネルギー（馬力）が非常に高いといえます。数値が高いほど不可能と思われるタスクに対しても、物事を成し遂げようとするエネルギーを保持し続ける事ができるといえます',
      },
    ],
  },
  {
    id: 'Charm',
    name: '魅力',
    range: [40, 100],
    text: [
      { range: [0, 30], text: '人を説得する能力や影響力は低い' },
      { range: [31, 50], text: '説得力や影響力が時折表れることがあるレベル' },
      {
        range: [51, 100],
        text: '複雑度の高い認知的タスクを解決するレベル。数値が高いほど説得力や組織力が発達している',
      },
    ],
    textForAdmin: [
      {
        range: [0, 30],
        text: '人を惹きつけ、説得・理解される能力や他者への影響力は低いといえます。他者からみられる魅力的な要素が低いともいえます',
      },
      {
        range: [31, 50],
        text: 'タスク（仕事や作業）の中に時折説得力や影響力が現れる場合があります。しかしそれが高度なタスクになると現れにくく、特質や魅力といった傾向には達しないことが多い',
      },
      {
        range: [51, 100],
        text: '人を惹きつけ説得・理解され、心から尊敬され従わせる魅力や特質があるといえます。数値が高いほど複雑な問題解決に対してもそれを達成する組織力を形成する事ができるといえます',
      },
    ],
  },
  {
    id: 'Balance',
    name: '安定性',
    range: [50, 100],
    text: [
      { range: [0, 50], text: 'バランスが悪く、態度が受動的な状態' },
      { range: [51, 60], text: '感情的反応としてほぼ基準を満たしている' },
      { range: [61, 100], text: '感情的反応として高い平衡レベルにある' },
    ],
    textForAdmin: [
      {
        range: [0, 50],
        text: '安定性に欠けており、精神的な均衡がとれていない状態といえます。怒りを直接的ではなく、遠回しに表現して相手を困らせようとする行動や態度に出る場合があります。受動的攻撃性が高いともいえます',
      },
      {
        range: [51, 60],
        text: '精神的な均衡がとれており、安定した状態といえます。肉体的・精神的つりあいがとれており、一般的基準を満たしているといえます',
      },
      {
        range: [61, 100],
        text: '精神的な均衡がとれており、非常に高いレベルの状態といえます。肉体的・精神的つりあいが高いレベルで保たれており、タスク（仕事や作業）に対して成果が得られやすい状態といえます',
      },
    ],
  },
  {
    id: 'Suspect',
    name: '疑心',
    range: [20, 50],
    text: [
      {
        range: [0, 100],
        text: 'ネガティブに属する攻撃性・緊張・ストレスの総合評価',
      },
    ],
    textForAdmin: [
      {
        range: [0, 100],
        text: '上記の攻撃性・緊張・ストレスの3要素から総合的に評価される数値となります。ネガティブな感情による潜在的危険性を表します。数値が高くなれば、周囲や社会に対する不満を他者へと向ける傾向が現れやすくなります。注意して接して下さい',
      },
    ],
  },
  {
    id: 'Tension/Anxiety',
    name: '緊張',
    range: [15, 40],
    text: [
      { range: [0, 15], text: '緊張の欠如、認知すべきタスクが無い状態' },
      {
        range: [16, 40],
        text: '認知すべき知的タスクを伴う緊張状態。数値が上がるほどタスクの複雑度が増している',
      },
      {
        range: [41, 100],
        text: '高い緊張状態。特定の知的タスクを完了できないことから生じる危機意識',
      },
    ],
    textForAdmin: [
      {
        range: [0, 15],
        text: '適度な緊張感が欠けて足りていない状態といえます。物ごとを認識・理解する心の働きが弱く何かを行おうとする意欲や学習成果に影響が出る場合が考えられます',
      },
      {
        range: [16, 40],
        text: '適度な緊張感があり安定した状態といえます。物ごとを認知・理解すべき知的意欲や学習成果には適した状態といえます。数値があがればより高度なタスク（仕事や作業）に貢献できる状態を示します',
      },
      {
        range: [41, 100],
        text: '過剰な緊張感があります。心配に思ったり恐怖を感じたりする不安な状態といえます。数値があがればより高い緊張状態を表し、タスク（仕事や作業）に成果がでにくい事が多いといえます。心配事や悩み事を抱えている可能性もあります',
      },
    ],
  },
  {
    id: 'Stress',
    name: 'ストレス',
    range: [20, 40],
    text: [
      { range: [0, 15], text: '休息や眠るときの典型的リラックス状態' },
      {
        range: [16, 40],
        text: 'リラックスした状態。または外的な刺激に対して適応できている状態',
      },
      {
        range: [41, 100],
        text: '生理的ストレス状態。抵抗力が低下し感情的に消耗している状態',
      },
    ],
    textForAdmin: [
      {
        range: [0, 15],
        text: '極めてストレスが少なく、休息や睡眠中のリラックスした状態であるといえます。逆にストレス値が低すぎるという事は、日々のタスク（仕事や作業）に対して楽な部分を感じているともいえます',
      },
      {
        range: [16, 40],
        text: '適度なストレスを感じておりリラックスした状態です。ストレスの原因となる外的要因や刺激に対して順応できている状態といえます。日々のタスク（仕事や作業）に対して成果が出やすい状態といえます',
      },
      {
        range: [41, 100],
        text: '重圧や苦悩を感じている状況といえます。生理的ストレス（空腹や疲労など）、物理的ストレス（暑さ・寒さ・ケガ等）、心理的・社会的ストレス（対人関係や悩み等）を強く感じています。抵抗力が低下し感情が限界に達する可能性があります。注意して接して下さい',
      },
    ],
  },
];
const chartLabelGroup: MentalTypes.ChartLabelGroup = {
  Positive: ['Self regulation', 'Energy', 'Charm', 'Balance'],
  Physiological: ['Neuroticism', 'Inhibition'],
  Negative: ['Aggression', 'Suspect', 'Tension/Anxiety', 'Stress'],
};
const chartLabelsSorted: MentalTypes.ChartLabelsSorted[] = [
  { id: 'Aggression', name: '攻撃性' },
  { id: 'Stress', name: 'ストレス' },
  { id: 'Tension/Anxiety', name: '緊張' },
  { id: 'Suspect', name: '疑心' },
  { id: 'Balance', name: '安定性' },
  { id: 'Charm', name: '魅力' },
  { id: 'Energy', name: '活力' },
  { id: 'Self regulation', name: '自制心' },
  { id: 'Inhibition', name: '抑圧' },
  { id: 'Neuroticism', name: '神経質' },
];
const chartLabels_mult: MentalTypes.ChartLabels_mult[] = [
  {
    id: 'Aggression',
    name: '攻撃性',
    down: 28.57,
    up: 71.43,
    mag: 1.429,
    range: [25, 75],
  },
  {
    id: 'Stress',
    name: 'ストレス',
    down: 33.33,
    up: 66.67,
    mag: 1.667,
    range: [25, 75],
  },
  {
    id: 'Tension/Anxiety',
    name: '緊張',
    down: 27.27,
    up: 72.73,
    mag: 1.818,
    range: [25, 75],
  },
  {
    id: 'Suspect',
    name: '疑心',
    down: 28.57,
    up: 71.43,
    mag: 1.429,
    range: [25, 75],
  },
  {
    id: 'Balance',
    name: '安定性',
    down: 33.33,
    up: 66.67,
    mag: 0.667,
    range: [25, 75],
  },
  {
    id: 'Charm',
    name: '魅力',
    down: 28.57,
    up: 71.43,
    mag: 0.714,
    range: [25, 75],
  },
  {
    id: 'Energy',
    name: '活力',
    down: 16.67,
    up: 83.33,
    mag: 1.667,
    range: [25, 75],
  },
  {
    id: 'Self regulation',
    name: '自制心',
    down: 33.33,
    up: 66.67,
    mag: 0.667,
    range: [25, 75],
  },
  {
    id: 'Inhibition',
    name: '抑圧',
    down: 28.57,
    up: 71.43,
    mag: 2.857,
    range: [25, 75],
  },
  {
    id: 'Neuroticism',
    name: '神経質',
    down: 16.67,
    up: 83.33,
    mag: 1.667,
    range: [25, 75],
  },
];
const graphImages = [
  { source: '/img/graph/01.png', text: '正常' },
  { source: '/img/graph/02.png', text: '疲労' },
  { source: '/img/graph/03.png', text: '非常に活発' },
  { source: '/img/graph/04.png', text: '活発' },
  { source: '/img/graph/05.png', text: '攻撃的' },
  {
    source: '/img/graph/06.png',
    text: '痛み又は不安定',
  },
  {
    source: '/img/graph/07.png',
    text: '睡眠に問題あり',
  },
  {
    source: '/img/graph/08.png',
    text: '痛み又は不安定',
  },
  { source: '/img/graph/09.png', text: '不安定' },
  {
    source: '/img/graph/10.png',
    text: '複数の問題アリ',
  },
];
const FileDownloadConfirmContent = () => {
  return (
    <Box>
      <ul>
        <li>結果 Excel ファイルは Windows にのみ対応しています</li>
        <li>
          ダウンロードした zip ファイルを右クリックして「すべて展開」します
        </li>
        <li>Excel ファイル ( xlsm 拡張子 ) を開きます</li>
        <li>( 確認された場合 )「編集を有効にする」を許可します</li>
        <li>( 確認された場合 )「コンテンツの有効化」を許可します</li>
      </ul>
    </Box>
  );
};
const ResultModal = ({
  index,
  list,
  user,
  open,
  onClose,
  onDelete,
  isMe,
  tags,
}: MentalTypes.ResultModalProps) => {
  const { dispatch } = React.useContext(Context);
  
  const theme = useTheme();
  const [menu, setMenu] = React.useState(0);
  const [openCompare, setOpenCompare] = React.useState(false);
  const [dateCompare, setDateCompare] = React.useState<
    dayjs.Dayjs[] | undefined
  >();
  const [dataElementCompare, setDataElementCompare] = React.useState<
    MentalTypes.Measurement | undefined
  >();
  const [showConfirm, setShowConfirm] = React.useState(false);
  const [showDownloadConfirm, setShowDownloadConfirm] = React.useState(false);
  const info = list?.[index].info;
  const resultFileDownload = () => {
    const fileName = list?.[index].fileName;
    if (fileName) {
      fbFunc('getMeasurementFileUrl', {
        userId: user?.userId,
        fileName,
      }).then((res) => {
        if (isErrFbFunc(dispatch, res)) {
          return;
        }
        if (res.signedUrl) {
          location.href = res.signedUrl;
        }
      });
    }
  };
  const onClickDownloadConfirm = () => {
    setShowDownloadConfirm(true);
  };
  const onClickDownload = () => {
    resultFileDownload();
  };
  const onResetCompare = () => {
    setDataElementCompare(undefined);
    setDateCompare(undefined);
  };
  const downloadEnable = !!list?.[index].fileName;
  React.useEffect(() => {
    if (dateCompare?.length === 2) {
      getMeasurementData({
        userId: user?.userId,
        compareFrom: dateCompare[0].format('YYYY-MM-DD 00:00:00'),
        compareTo: dateCompare[1].format('YYYY-MM-DD 23:59:59'),
        modeCompare: 2,
      }).then((measure) => {
        if (measure) {

          {measure.map((v, i) => {
                  
            v.base.Aggression.M2= calMeasure("Aggression",v.base.Aggression.M,v.base.Aggression.M2);
            v.base.Stress.M2= calMeasure("Stress",v.base.Stress.M,v.base.Stress.M2);
            v.base['Tension/Anxiety'].M2= calMeasure("Tension/Anxiety",v.base['Tension/Anxiety'].M,v.base['Tension/Anxiety'].M2);
            v.base.Suspect.M2= calMeasure("Suspect",v.base.Suspect.M,v.base.Suspect.M2);
            v.base.Balance.M2= calMeasure("Balance",v.base.Balance.M,v.base.Balance.M2);
            v.base.Charm.M2= calMeasure("Charm",v.base.Charm.M,v.base.Charm.M2);
            v.base.Energy.M2= calMeasure("Energy",v.base.Energy.M,v.base.Energy.M2);
            v.base['Self regulation'].M2= calMeasure("Self regulation",v.base['Self regulation'].M,v.base['Self regulation'].M2);
            v.base.Inhibition.M2= calMeasure("Inhibition",v.base.Inhibition.M,v.base.Inhibition.M2);
            v.base.Neuroticism.M2= calMeasure("Neuroticism",v.base.Neuroticism.M,v.base.Neuroticism.M2);
            
        })}

          setDataElementCompare(measure[0]);
        }
      });
    }
  }, [dateCompare]);
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth={false}
      PaperProps={{ sx: { maxWidth: "revert", width: 1280 } }}
    >
      {showDownloadConfirm && (
        <ConfirmDialog
          onOk={onClickDownload}
          onCancel={() => setShowDownloadConfirm(false)}
          title={`結果ファイルのDL`}
          message={<FileDownloadConfirmContent />}
          okButton="ダウンロード"
        />
      )}
      <Box p={2}>
        {/* -- header */}
        <Grid_Center
          container
          spacing={2}
        >
          {downloadEnable && (
            <Grid item md={4} xs={12} container>
              <Button
                type="button"
                variant="contained"
                color="primary"
                onClick={onClickDownloadConfirm}
                startIcon={<CloudDownloadIcon />}
              >
                結果ファイルのDL
              </Button>
            </Grid>
          )}
          <Grid item style={{ flexGrow: 1 }}>
            <Grid_Center
              container
              direction="column"
              spacing={1}
            >
              <Grid item>
                <Grid_Center
                  container
                  direction="row"
                >
                  <Grid item>
                    <Box color={'primary'}>
                      <Typography>
                        {info?.dtRange || getJpTimeStr(info?.dt)}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid_Center>
              </Grid>
              <Grid item>
                <ButtonGroup>
                  {['評価要素', '感情分布', '周波数'].map((v, i) => (
                    i === menu ? 
                    <Button
                      key={i}
                      onClick={() => setMenu(i)}
                      color={'primary'}
                      variant={'contained'}
                    >
                      {v}
                    </Button>
                    :

                    <Button_out
                      key={i}
                      onClick={() => setMenu(i)}

                      variant={'outlined'}
                    >
                      {v}
                    </Button_out>

                  ))}
                </ButtonGroup>
              </Grid>
            </Grid_Center>
          </Grid>
          <Grid_Flexend item md={4} xs={12} container>
            <Button
              type="button"
              variant="contained"
              color="secondary"
              onClick={() => setOpenCompare(true)}
              startIcon={<CompareArrowsIcon />}
            >
              データ比較
              {dateCompare?.length === 2
                ? '｜' +
                  dateCompare[0].format('MM-DD') +
                  ' - ' +
                  dateCompare[1].format('MM-DD')
                : ''}
            </Button>
            {dateCompare?.length === 2 && (
              <IconButton
                color="default"
                size="small"
                onClick={onResetCompare}
                style={{
                  marginLeft: theme.spacing(1),
                }}
              >
                <CancelIcon />
              </IconButton>
            )}
          </Grid_Flexend>
          {openCompare && (
            <ResultModalCompare
              open={openCompare}
              onClose={() => setOpenCompare(false)}
              date={dateCompare}
              setDate={setDateCompare}
            />
          )}
        </Grid_Center>
        {/* header -- */}
        {/* -- contents */}
        <Box py={4} px={1}>
          {/* -- element area */}
          {menu === 0 && (
            <ResultModalElement
              list={list}
              index={index}
              user={user}
              dataElementCompare={dataElementCompare}
              isMe={isMe}
              tags={tags}
            />
          )}
          {/* element area -- */}
          {/* -- emotion area */}
          {menu === 1 && (
            <ResultModalEmotion
              list={list}
              index={index}
              dataElementCompare={dataElementCompare}
            />
          )}
          {/* emotion area -- */}
          {menu === 2 && (
            <ResultModalGraph
              list={list}
              index={index}
              dataElementCompare={dataElementCompare}
            />
          )}
        </Box>
        {/* -- contents */}
      </Box>
      {isMe && (
        <Box display="flex" justifyContent="flex-end" p={2}>
          <Button
            type="button"
            variant="contained"
            color="secondary"
            onClick={() => setShowConfirm(true)}
            startIcon={<DeleteIcon />}
          >
            削除を確認
          </Button>
        </Box>
      )}
      {showConfirm && (
        <ConfirmDialog
          onOk={() => onDelete(index)}
          onCancel={() => setShowConfirm(false)}
          title={`データの削除`}
          message="この操作は取り消せません。よろしいですか？"
        />
      )}
    </Dialog>
  );
};
const ResultModalElement = ({
  list,
  index,
  user,
  dataElementCompare,
  isMe,
  tags,
}: MentalTypes.ResultModalElementProps) => {

  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const [faceImageUrl, setFaceImageUrl] = React.useState('');
  const rangeElements = React.useMemo(() => {
    return [1, 0].map((v) => {
      const base: Partial<Record<MentalTypes.DataElementKey, number>> = {};
      chartLabels.forEach((vv) => {
        base[vv.id as MentalTypes.DataElementKey] = vv.range[v];
      });
      return base;
    });
  }, []);
  const dataElements = React.useMemo(() => {
    return [list?.[index], dataElementCompare]
      .map((v) => {
        if (!v) {
          return null;
        }
        const { base } = v;
        if (base) {
          const dataElement: Partial<
            Record<MentalTypes.DataElementKey, number>
          > = {};
          (Object.keys(base) as MentalTypes.DataElementKey[]).map((k) => {
            dataElement[k] = base[k].M;
          });
          return dataElement;
        }
        return null;
      })
      .filter(Boolean);
  }, [index, dataElementCompare]);
  const dataElements_50 = React.useMemo(() => {
    return [list?.[index], dataElementCompare]
      .map((v) => {
        if (!v) {
          return null;
        }
        const { base } = v;
        if (base) {
          const dataElement: Partial<
            Record<MentalTypes.DataElementKey, number>
          > = {};
          (Object.keys(base) as MentalTypes.DataElementKey[]).map((k) => {
            dataElement[k] = base[k].M2;
          });
          return dataElement;
        }
        return null;
      })
      .filter(Boolean);
  }, [index, dataElementCompare]);
  React.useEffect(() => {
    fbFunc('getMeasurementFaceImage', {
      userId: user?.userId,
      measurementId: list?.[index].fileName,
    }).then((res) => {
      if (res.signedUrl) {
        setFaceImageUrl(res.signedUrl);
      }
    });
  }, []);
  return (
    <Grid container direction="row">
      {/* -- element chart */}
      <Grid item md={4} container direction="column" alignItems="center">
        <Box my={4}>
          <Grid
            item
            container
            direction="column"
            alignItems="center"
            spacing={2}
          >
            <Grid item>
              <Avatar_resultModalElementAvatar
                src={faceImageUrl}
              />
            </Grid>
            <Grid item>
              <Box textAlign="center">{`${user?.nameLast}${user?.nameFirst} / ${user?.userId}`}</Box>
            </Grid>
            <Grid_Center2 item container spacing={1}>
              {tags
                ?.filter((tag) => tag.tagName !== '企業')
                .map((tag, i) => (
                  <Grid key={i} item>
                    <Chip 
                      label={tag.tagName} 
                      style={
                        isDark ?
                        {backgroundColor: 'gray'}
                        :
                        {backgroundColor: 'lightgray'}
                      }
                    />
                  </Grid>
                ))}
            </Grid_Center2>
          </Grid>
        </Box>
        <Grid item>
          <VictoryChart
            polar
            theme={VictoryTheme.material}
            domain={{ y: [0, 100] }}
            startAngle={90}
            endAngle={450}
            padding={{ top: 60, right: 20, bottom: 60, left: 20 }}
            events={[
              {
                childName: [...Array(10)].map((_v, i) => {
                  return 'axisLabel-' + i;
                }),
                target: 'labels',
                eventHandlers: {
                  onPress: () => {
                    return [
                      {
                        mutation: () => {
                          return null;
                        },
                      },
                    ];
                  },
                },
              },
            ]}
          >
            {chartLabels.map((v, i) => (
              <VictoryPolarAxis
                key={i}
                dependentAxis
                name={'axisLabel-' + i}
                style={{
                  axis: { stroke: 'none' },
                  grid: {
                    stroke: isDark ? 'white' : 'grey',
                    opacity: 0.5,
                    strokeWidth: 0.25,
                  },
                  axisLabel: {
                    fontSize: 14,
                    padding: 18,
                    fill: isDark ? 'white' : 'grey',
                  },
                }}
                labelPlacement="perpendicular"
                axisValue={i + 1}
                label={v.name}
                tickFormat={() => ''}
                tickValues={[25, 50, 75, 100]}
              />
            ))}
            {rangeElements.map((v, i) => {
              if (!v) {
                return null;
              }
              const vv = chartLabels.map((k) => {
                return {
                  x: k.id,
                  y: v[k.id],
                };
              });
              return (
                <VictoryGroup
                  key={i}
                  style={{
                    data: {
                      fillOpacity: i === 0 ? 0.25 : 1,
                      strokeWidth: 0,
                      fill:
                        i === 0
                          ? isDark
                            ? 'gray'
                            : 'gold'
                          : theme.palette.background.paper,
                    },
                  }}
                  sortKey={'x'}
                >
                  <VictoryArea data={vv} />
                </VictoryGroup>
              );
            })}
            {dataElements.map((v, i) => {
              if (!v) {
                return null;
              }
              const vv = chartLabels.map((k) => {
                return {
                  x: k.id,
                  y: v[k.id],
                };
              });
              return (
                <VictoryGroup
                  key={i}
                  style={{
                    data: {
                      fillOpacity: 0,
                      strokeWidth: 3,
                      stroke: [
                        theme.palette.primary.main,
                        theme.palette.secondary.main,
                      ][i],
                    },
                  }}
                  sortKey={'x'}
                >
                  <VictoryArea data={vv} />
                </VictoryGroup>
              );
            })}
            <VictoryPolarAxis
              labelPlacement="parallel"
              tickFormat={() => ''}
              style={{
                axis: { stroke: 'none' },
                grid: { stroke: isDark ? 'white' : 'grey', opacity: 0.5 },
              }}
            />
          </VictoryChart>
        </Grid>
      </Grid>
      {/* element chart -- */}
      {/* -- element chart text table -- */}
      <Grid item md={8}>
        <TableContainer component={Paper} sx={{marginTop:theme.spacing(2)}}>
          <Table_resultModalTable>
            <TableHead>
              <TableRow>
                <TableCell_noWrap align="center">
                  項目
                </TableCell_noWrap>
                <TableCell_noWrap align="center">
                  基準値
                </TableCell_noWrap>
                <TableCell_noWrap align="center">
                  結果
                </TableCell_noWrap>
                {dataElementCompare && (
                  <TableCell_noWrap align="center">
                    比較
                  </TableCell_noWrap>
                )}
                <TableCell align="center">コメント</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {chartLabelsSorted.map((v, i) => {
                const chartLabel = chartLabels.find((vv) => {
                  return vv.id === v.id;
                });
                if (!chartLabel) {
                  return null;
                }

                const chartLabel_mult = chartLabels_mult.find((vv) => {
                  return vv.id === v.id;
                });
                if (!chartLabel_mult) {
                  return null;
                }

                const range = chartLabel.range[0] + ' - ' + chartLabel.range[1];
                const value = dataElements?.[0]?.[v.id] || 0;
                const value_50 = dataElements_50?.[0]?.[v.id] || 0;
                const textArray = isMe
                  ? chartLabel.text
                  : chartLabel.textForAdmin;
                const textOne = textArray.find((vv) => {
                  return (
                    Math.floor(value) >= vv.range[0] &&
                    Math.floor(value) <= vv.range[1]
                  );
                });
                const text = textOne ? textOne.text : '';
                const valueCompare = dataElements?.[1]?.[v.id] ?? -1;
                const valueCompare_50 = dataElements_50?.[1]?.[v.id] ?? -1;
                const alert = isElementAlert(v.id, value);
                const alertCompare =
                  valueCompare >= 0 && isElementAlert(v.id, valueCompare);
                return (
                  <TableRow key={i}>
                    <TableCell_noWrap align="center">
                      {v.name}
                    </TableCell_noWrap>
                    <TableCell_noWrap align="center">
                      <Box color="text.secondary">{range}</Box>
                    </TableCell_noWrap>
                    <TableCell_noWrap align="center">
                    
                    {alert ? 
                      <Box_alertBox
                        color="primary.main"
                      >
                        {value.toFixed(1)}
                      </Box_alertBox>
                    :
                      <Box
                        color="primary.main"
                      >
                        {value.toFixed(1)}
                    </Box>
                    }
                      
                    </TableCell_noWrap>
                    {dataElements?.[1] && (
                      <TableCell_noWrap align="center">
                        {alertCompare ? true :
                          <Box_alertBox
                            color="secondary.main"
                          >
                            {valueCompare >= 0 ? valueCompare.toFixed(1) : '--'}
                          </Box_alertBox>
                        }

                        {alertCompare ? false :
                          <Box
                            color="secondary.main"
                          >
                            {valueCompare >= 0 ? valueCompare.toFixed(1) : '--'}
                          </Box>
                        }
                      </TableCell_noWrap>
                    )}
                    <TableCell>
                      <Box_font12>{text}</Box_font12>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table_resultModalTable>
        </TableContainer>
      </Grid>
      {/* element chart text table -- */}
    </Grid>
  );
};
const ResultModalEmotion = ({
  list,
  index,
  dataElementCompare,
}: MentalTypes.ResultModalEmotionProps) => {
  
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const dataGroup = [list?.[index], dataElementCompare]
    .map((v) => {
      if (!v) {
        return null;
      }
      const { base } = v;
      const sums = (
        [
          'Positive',
          'Physiological',
          'Negative',
        ] as (keyof MentalTypes.ChartLabelGroup)[]
      ).map((k) => {
        return chartLabelGroup[k].reduce(
          (acc: number, cur: MentalTypes.DataElementKey) => {
            return acc + base[cur].M * 10;
          },
          0
        );
      });
      return [
        { n: 0, id: 0, x: 'ポジティブ', y: Math.round(sums[0] / 4) / 10 },
        { n: 1, id: 2, x: '生理的反応', y: Math.round(sums[1] / 2) / 10 },
        { n: 2, id: 1, x: 'ネガティブ', y: Math.round(sums[2] / 4) / 10 },
      ];
    })
    .filter(Boolean);
  const emotionText = dataGroup.map((d) => {
    const v = d?.map((v) => {
      return v.y;
    });
    if (!v) {
      return '';
    }
    if (v[0] > v[1] && v[1] > v[2]) {
      if (v[0] >= 50) {
        return '精神的にも気分がよく身体的にも正常の範囲内';
      } else {
        return 'リラックスした状態ではあるが身体的又は精神的に疲労の可能性あり';
      }
    } else if (v[0] > v[2] && v[2] > v[1]) {
      if (v[0] >= 50) {
        return '精神的には気分がよい。身体的には疲労の可能性もあり';
      } else {
        return '精神的又は身体的な疲労。活動に対する意欲の低下などの可能性';
      }
    } else if (v[1] > v[0] && v[0] > v[2]) {
      return '要注意。気分が悪い。精神的(ストレスや疲労)要因';
    } else if (v[1] > v[2] && v[2] > v[0]) {
      return '要注意。気分が悪い。気分が悪い要因が身体的問題(病気や疲労)';
    } else if (v[2] > v[0] && v[0] > v[1]) {
      return '要注意。身体的(病気、炎症など)要因で、気分も良くない';
    } else if (v[2] > v[1] && v[1] > v[0]) {
      return '要注意。身体的および精神的の両方にトラブルの可能性あり';
    }
  });
  return (
    <Grid container direction="row">
      <Grid item sm={6} container alignItems="center">
        <VictoryChart
          polar
          theme={VictoryTheme.material}
          domain={{ y: [0, 100] }}
          startAngle={90}
          endAngle={450}
          padding={{ top: 20, right: 60, bottom: 20, left: 60 }}
        >
          {['ポジティブ', '生理的現象', 'ネガティブ'].map((v, i) => (
            <VictoryPolarAxis
              key={i}
              dependentAxis
              style={{
                axis: { stroke: 'none' },
                grid: {
                  stroke: isDark ? 'white' : 'grey',
                  opacity: 0.5,
                  strokeWidth: 0.25,
                },
                axisLabel: {
                  fontSize: 14,
                  padding: 14,
                  fill: isDark ? 'white' : 'grey',
                },
              }}
              labelPlacement="perpendicular"
              axisValue={i + 1}
              label={v}
              tickFormat={() => ''}
              tickValues={[25, 50, 75, 100]}
            />
          ))}
          {dataGroup.map((v: any, i) => (
            <VictoryGroup
              key={i}
              style={{
                data: {
                  fillOpacity: 0,
                  strokeWidth: 2,
                  stroke: [
                    theme.palette.primary.main,
                    theme.palette.secondary.main,
                  ][i],
                },
              }}
            >
              <VictoryArea data={v} />
            </VictoryGroup>
          ))}
          <VictoryPolarAxis
            labelPlacement="parallel"
            tickFormat={() => ''}
            style={{
              axis: { stroke: 'none' },
              grid: { stroke: isDark ? 'white' : 'grey', opacity: 0.5 },
            }}
          />
        </VictoryChart>
      </Grid>
      <Grid item sm={6}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="center">項目</TableCell>
                <TableCell align="center">結果</TableCell>
                {dataGroup?.length === 2 && (
                  <TableCell align="center">比較</TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {[...(dataGroup?.[0] ?? [])]
                .sort((a, b) => {
                  if (a.id < b.id) return -1;
                  if (a.id > b.id) return 1;
                  return 0;
                })
                .map((v, i) => (
                  <TableRow key={i}>
                    <TableCell align="center">{v.x}</TableCell>
                    <TableCell align="center">{v.y.toFixed(1)}</TableCell>
                    {dataGroup[1] && (
                      <TableCell align="center">
                        {dataGroup[1][v.n].y.toFixed(1)}
                      </TableCell>
                    )}
                  </TableRow>
                ))}
              <TableRow>
                <TableCell_noWrap align="center">
                  評価コメント
                </TableCell_noWrap>
                <TableCell colSpan={2}>
                  <Box_font12>{emotionText[0]}</Box_font12>
                  {dataGroup[1] && (
                    <Box_font12>{emotionText[1]}</Box_font12>
                  )}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};
const ResultModalGraph = ({
  list,
  index,
  dataElementCompare,
}: MentalTypes.ResultModalGraphProps) => {
  const theme = useTheme();

  const dataFH = [list?.[index], dataElementCompare]
    .map((v) => {
      if (!v) {
        return null;
      }
      const { fh } = v;
      return fh?.map((v, i) => {
        return {
          x: i * 0.02,
          y: v,
        };
      });
    })
    .filter(Boolean);
  return (
    <Grid container direction="row">
      <Grid item sm={6} container alignItems="center">
        <VictoryChart
          theme={VictoryTheme.material}
          width={400}
          height={400}
          padding={{ top: 30, right: 50, bottom: 30, left: 50 }}
        >
          <VictoryAxis crossAxis tickFormat={() => ''} />
          <VictoryAxis crossAxis dependentAxis tickFormat={() => ''} />
          {dataFH.map((v, i) => (
            <VictoryLine
              key={i}
              data={v ?? []}
              style={{
                data: {
                  stroke:
                    i === 0
                      ? theme.palette.primary.main
                      : theme.palette.secondary.main,
                  fill:
                    i === 0
                    ? theme.palette.primary.main
                    : theme.palette.secondary.main,
                  fillOpacity:
                    i === 0
                    ? 1.0
                    : 0.2
                },
              }}
            />
          ))}
        </VictoryChart>
      </Grid>
      <Grid item sm={6}>
        <Grid_Center container spacing={2}>
          {graphImages.map((v, i) => {
            return (
              <Grid key={i} item>
                <Box display="flex" alignItems="center" flexDirection="column">
                  <Box>
                    <img
                      src={v.source}
                      style={{
                        width: '5.5rem',
                        height: '3.0rem',
                      }}
                    />
                  </Box>
                  <Box_font12>{v.text}</Box_font12>
                </Box>
              </Grid>
            );
          })}
        </Grid_Center>
      </Grid>
    </Grid>
  );
};
const ResultModalCompare = ({
  open,
  onClose,
  date,
  setDate,
  mode = 0,
  setMode,
}: MentalTypes.ResultModalCompareProps) => {
  const [dateFrom, setDateFrom] = React.useState<dayjs.Dayjs>(
    date?.[0] ?? dayjs().add(-7, 'day')
  );
  const [dateTo, setDateTo] = React.useState<dayjs.Dayjs>(
    date?.[1] ?? dayjs().add(-1, 'day')
  );
  const minDate = dayjs().add(-60, 'day');
  const maxDate = dayjs().add(-1, 'day');
  const [modeTemp, setModeTemp] = React.useState(mode);
  const onApply = () => {
    setDate([dateFrom, dateTo]);
    if (setMode) {
      setMode(modeTemp);
    }
    onClose();
  };
  const onChangeMode = (event: React.ChangeEvent<HTMLInputElement>) => {
    setModeTemp(event.target.checked ? 2 : 1);
  };
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm">
      <DialogTitle>{mode ? '期間指定' : 'データ比較'}</DialogTitle>
      <DialogContent>
        <Box sx={{marginTop:'10px'}}>
          <LocalizationProvider 
            dateAdapter={AdapterDayjs}
            dateFormats={{
              month:'MM月',
              year:'YYYY年'
            }}
            adapterLocale='jaJP'
            localeText={{
              previousMonth: '前月を表示',
              nextMonth:'次月を表示'
            }}
            
          >
            <Grid container spacing={2}>
              <Grid item>
                <DatePicker
                  label="開始日"
                  format="YYYY/MM/DD"
                  value={dateFrom}
                  onChange={(date) => setDateFrom(dayjs(date))}
                  maxDate={dateTo}
                  minDate={minDate}
                  
                />
              </Grid>
              <Grid item>
                <DatePicker
                  label="終了日"
                  format="YYYY/MM/DD"
                  value={dateTo}
                  onChange={(date) => setDateTo(dayjs(date))}
                  maxDate={maxDate}
                  minDate={dateFrom}
                />
              </Grid>
            </Grid>
          </LocalizationProvider>
        </Box>
        {mode > 0 && (
          <FormControlLabel
            control={
              <Checkbox
                checked={modeTemp === 2}
                onChange={onChangeMode}
                value="2"
                color="default"
              />
            }
            label="期間内の平均値を表示"
          />
        )}
      </DialogContent>
      <DialogActions
        style={{ marginRight: '1.0rem'}}
      >
        <Button
          type="submit"
          variant="contained"
          color="primary"
          onClick={onApply}
        >
          {'適用'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
const ResultList = () => {
  const { state } = React.useContext(Context);
  const { user } = state;
  return <ResultListTable user={user} isMe={true} />;
};
const ResultListTable = ({ user, isMe }: MentalTypes.ResultListTableProps) => {
  
  const theme = useTheme();
  const { dispatch, state } = React.useContext(Context);
  const { user: me } = state;
  const [list, setList] = React.useState<
    MentalTypes.Measurement[] | undefined
  >();
  const [index, setIndex] = React.useState(-1);
  const [showResultModal, setShowResultModal] = React.useState(false);
  const [showCameraModal, setShowCameraModal] = React.useState(false);
  const [openCompare, setOpenCompare] = React.useState(false);
  const [dateCompare, setDateCompare] = React.useState<
    dayjs.Dayjs[] | undefined
  >();
  const [modeCompare, setModeCompare] = React.useState(1);
  const [tags, setTags] = React.useState<MentalTypes.Tag[] | undefined>();
  const loading = React.useRef(false);
  const reachEnd = React.useRef(false);
  const fetchList = React.useCallback(
    (reset = false) => {
      const limit = 30;
      if (user?.userId && !reachEnd.current && !loading.current) {
        loading.current = true;
        const createdAt = list?.slice(-1)[0]?.createdAt;
        
        const after =
          (!reset && typeof createdAt === 'object'
            ? dayjs(createdAt?.seconds * 1000).format('YYYY-MM-DD HH:mm:ss')
            : undefined) ?? undefined;
        const compareFrom = dateCompare?.[0]?.format('YYYY-MM-DD 00:00:00');
        const compareTo = dateCompare?.[1]?.format('YYYY-MM-DD 23:59:59');
        getMeasurementData({
          userId: user.userId,
          after,
          compareFrom,
          compareTo,
          modeCompare,
          dataLimit: limit,
        })
          .then((measure) => {
            if (measure) {
              if (reset) {


                setList(measure);

                
                {measure.map((v, i) => {
                  
                  v.base.Aggression.M2= calMeasure("Aggression",v.base.Aggression.M,v.base.Aggression.M2);
                  v.base.Stress.M2= calMeasure("Stress",v.base.Stress.M,v.base.Stress.M2);
                  v.base['Tension/Anxiety'].M2= calMeasure("Tension/Anxiety",v.base['Tension/Anxiety'].M,v.base['Tension/Anxiety'].M2);
                  v.base.Suspect.M2= calMeasure("Suspect",v.base.Suspect.M,v.base.Suspect.M2);
                  v.base.Balance.M2= calMeasure("Balance",v.base.Balance.M,v.base.Balance.M2);
                  v.base.Charm.M2= calMeasure("Charm",v.base.Charm.M,v.base.Charm.M2);
                  v.base.Energy.M2= calMeasure("Energy",v.base.Energy.M,v.base.Energy.M2);
                  v.base['Self regulation'].M2= calMeasure("Self regulation",v.base['Self regulation'].M,v.base['Self regulation'].M2);
                  v.base.Inhibition.M2= calMeasure("Inhibition",v.base.Inhibition.M,v.base.Inhibition.M2);
                  v.base.Neuroticism.M2= calMeasure("Neuroticism",v.base.Neuroticism.M,v.base.Neuroticism.M2);
                  
                })}
                
                
                
              } else {


                setList([...(list ?? []), ...measure]);

                {measure.map((v, i) => {
                  
                  v.base.Aggression.M2= calMeasure("Aggression",v.base.Aggression.M,v.base.Aggression.M2);
                  v.base.Stress.M2= calMeasure("Stress",v.base.Stress.M,v.base.Stress.M2);
                  v.base['Tension/Anxiety'].M2= calMeasure("Tension/Anxiety",v.base['Tension/Anxiety'].M,v.base['Tension/Anxiety'].M2);
                  v.base.Suspect.M2= calMeasure("Suspect",v.base.Suspect.M,v.base.Suspect.M2);
                  v.base.Balance.M2= calMeasure("Balance",v.base.Balance.M,v.base.Balance.M2);
                  v.base.Charm.M2= calMeasure("Charm",v.base.Charm.M,v.base.Charm.M2);
                  v.base.Energy.M2= calMeasure("Energy",v.base.Energy.M,v.base.Energy.M2);
                  v.base['Self regulation'].M2= calMeasure("Self regulation",v.base['Self regulation'].M,v.base['Self regulation'].M2);
                  v.base.Inhibition.M2= calMeasure("Inhibition",v.base.Inhibition.M,v.base.Inhibition.M2);
                  v.base.Neuroticism.M2= calMeasure("Neuroticism",v.base.Neuroticism.M,v.base.Neuroticism.M2);
                  
                })}

              }
            }
            if (measure.length < limit) {
              reachEnd.current = true;
            }
          })
          .finally(() => {
            loading.current = false;
          });
      }
    },
    [user, list, dateCompare, modeCompare]
  );

  const onSelect = (index: number) => {
    setIndex(index);
    setShowResultModal(true);
  };
  const onClickAdd = () => {
    fbFunc('isMeasurementEnabled').then((res) => {
      if (isErrFbFunc(dispatch, res)) {
        return;
      }
      const { recCountPerDay, countToday } = res;
      if (recCountPerDay > countToday) {
        setShowCameraModal(true);
      } else {
        showToast(
          dispatch,
          `1 日に撮影できるのは ${
            recCountPerDay || recCountPerDayDefault
          } 回までです`
        );
      }
    });
  };
  const onCloseCamera = () => {
    location.reload();
  };
  const onScrollEnd = () => {
    fetchList();
  };
  const onResetCompare = () => {
    setModeCompare(1);
    setDateCompare(undefined);
  };
  const onDelete = (index: number) => {
    setDoc(
      doc(
        collection(doc(collection(db, 'users'), user?.userId), 'measurement'),
        list?.[index].measurementId
      ),
      {
        deleted: true,
      }
    ).then(() => {
      list?.splice(index, 1);
      setList(list);
      showToast(dispatch, 'データを削除しました');
      setShowResultModal(false);
    });
  };
  const refetch = () => {
    reachEnd.current = false;
    setList(undefined);
    fetchList(true);
  };
  React.useEffect(() => {
    refetch();
  }, [user, dateCompare]);
  React.useEffect(() => {
    if (me?.tagIdsAdmin && user?.tagIds) {
      getTags(me.tagIdsAdmin, user?.tagIds).then((res) => setTags(res));
    }
  }, [me]);
  return (
    <Box_page>
      <Box display="flex">
        <Box flexGrow={1} display="flex" alignItems="center">
          <Typography variant="h6">{`${user?.nameLast} ${user?.nameFirst}`}</Typography>
        </Box>
        <Box alignSelf="flex-end">
          <Button
            variant="contained"
            color="secondary"
            startIcon={<AssignmentIcon />}
            onClick={() => setOpenCompare(true)}
          >
            期間{modeCompare === 2 ? '平均' : '指定'}
            {dateCompare?.[0] && dateCompare?.[1]
              ? '｜' +
                dateCompare[0].format('MM-DD') +
                ' - ' +
                dateCompare[1].format('MM-DD')
              : ''}
          </Button>
          {Boolean(dateCompare?.[0] && dateCompare?.[1]) && (
            <IconButton
              color="default"
              size="small"
              onClick={onResetCompare}
              style={{
                marginLeft: theme.spacing(1),
              }}
            >
              <CancelIcon />
            </IconButton>
          )}
        </Box>
      </Box>
      <TableContainer component={Paper} sx={{maxHeight: 'calc(100% - 60px)', marginTop:theme.spacing(2)}}>
        <Table_resultTable stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell align="center">日時</TableCell>
              {(
                Object.keys(chartLabelsName) as MentalTypes.DataElementKey[]
              ).map((v, i) => (
                <TableCell key={i} align="center">
                  {chartLabelsName[v]}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {!list?.length && (
              <TableRow>
                <TableCell colSpan={99} align="center">
                  {list ? 'データは存在しないようです' : <Loading />}
                </TableCell>
              </TableRow>
            )}
            {list?.map((v, i) => (
              <TableRow_clickable
                key={i}
                onClick={() => onSelect(i)}
                hover
              >
                <TableCell align="center">
                  <Box>{v.info.dtRange ?? getJpTimeStr(v.info.dt)}</Box>
                </TableCell>
                {(
                  Object.keys(chartLabelsName) as MentalTypes.DataElementKey[]
                ).map((kk, ii) => {
                  const value = v.base[kk].M;
                  const value_50 = Number(v.base[kk].M2);
                  const alert = isElementAlert(kk, value);
                  return (
                    <TableCell key={i + '-' + ii} align="center">
                      { alert ? 
                        <Box_alertBox
                          color="primary.main"
                        >
                          {value.toFixed(1)}
                        </Box_alertBox>
                       :
                        <Box
                          color="primary.main"
                        >
                          {value.toFixed(1)}
                        </Box>
                      }
                    </TableCell>
                  );
                })}
              </TableRow_clickable>
            ))}
            <TableRow>
              <TableCell
                style={{
                  padding: 1,
                }}
              >
                <Waypoint onEnter={onScrollEnd} />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table_resultTable>
      </TableContainer>
      <Box
        position="absolute"
        right={0}
        bottom={theme.spacing(1)}
        display="flex"
      >
        <Fab color="secondary" onClick={refetch}>
          <RefreshIcon />
        </Fab>
        {isMe && (
          <Hidden xsDown>
            <Fab
              color="secondary"
              onClick={onClickAdd}
              style={{
                marginLeft: theme.spacing(1),
              }}
            >
              <AddIcon />
            </Fab>
          </Hidden>
        )}
      </Box>
      {showResultModal && (
        <ResultModal
          open={showResultModal}
          onClose={() => setShowResultModal(false)}
          onDelete={onDelete}
          index={index}
          list={list}
          user={user}
          isMe={isMe}
          tags={tags}
        />
      )}
      {showCameraModal && (
        <CameraModal open={showCameraModal} onClose={onCloseCamera} />
      )}
      {openCompare && (
        <ResultModalCompare
          open={openCompare}
          onClose={() => setOpenCompare(false)}
          date={dateCompare}
          setDate={setDateCompare}
          mode={modeCompare}
          setMode={setModeCompare}
        />
      )}
    </Box_page>
  );
};

const accountLimitDefault = 10;
const recSecDefault = 60;
const recCountPerDayDefault = 3;
const Company = () => {
  
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const { state, dispatch } = React.useContext(Context);
  const { user } = state;
  const [companies, setCompanies] = React.useState<
    MentalTypes.CompanyData[] | undefined
  >();
  const [companyName, setCompanyName] = React.useState('');
  const [accountLimit, setAccountLimit] = React.useState(accountLimitDefault);
  const [recSec, setRecSec] = React.useState(recSecDefault);
  const [recCountPerDay, setRecCountPerDay] = React.useState(
    recCountPerDayDefault
  );
  const [infoTitle, setInfoTitle] = React.useState('');
  const [infoText, setInfoText] = React.useState('');
  const [company, setCompany] = React.useState<
    MentalTypes.CompanyData | undefined
  >();
  const [showConfirm, setShowConfirm] = React.useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [refetch, setRefetch] = React.useState(0);
  React.useEffect(() => {
    if (user?.userId) {
      getCompaniesData().then((res) => {
        setCompanies(res ?? []);
      });
    }
  }, [user, refetch]);
  const onEditCompany = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!companyName) {
      showToast(dispatch, '入力されていない値があります');
      return;
    }
    setLoading(dispatch, true);
    const res = await fbFunc('setCompanyData', {
      company,
      companyName,
      accountLimit,
      infoText,
      infoTitle,
      recSec,
      recCountPerDay,
    });
    setLoading(dispatch, false);
    if (!res || res?.status !== 'success') {
      showToast(dispatch, res.message || 'エラーが発生しました');
      return;
    }
    setModalOpen(false);
    const msgSuffix = company ? '編集' : '追加';
    showToast(dispatch, `${companyName} を${msgSuffix}しました`);
    if (company) {
      setRefetch(refetch + 1);
    } else {
      getUserData(dispatch, user?.userId);
    }
  };
  const onDeleteCompany = async () => {
    setLoading(dispatch, true);
    const res = await fbFunc('deleteCompanyData', {
      companyId: company?.companyId,
    });
    setLoading(dispatch, false);
    if (!res) {
      showToast(dispatch, `${company?.companyName} の削除に失敗しました`);
      return;
    }
    setShowConfirm(false);
    showToast(dispatch, `${company?.companyName} を削除しました`);
    setModalOpen(false);
    getUserData(dispatch, user?.userId);
  };
  const onSelectCompany = (company_?: MentalTypes.CompanyData) => {
    setFormData(company_);
    setModalOpen(true);
  };
  const setFormData = (company_?: MentalTypes.CompanyData) => {
    setCompany(company_);
    setCompanyName(company_?.companyName || '');
    setAccountLimit(company_?.accountLimit || accountLimitDefault);
    setInfoTitle(company_?.infoTitle || '');
    setInfoText(company_?.infoText || '');
    setRecSec(company_?.recSec || recSecDefault);
    setRecCountPerDay(company_?.recCountPerDay || recCountPerDayDefault);
  };
  return (
    <Box_page>
      <TableContainer component={Paper} sx={{maxHeight: 'calc(100% - 20px)'}}>
        <Table_companyTable stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell align="center">企業</TableCell>
              <TableCell align="center">タグ</TableCell>
              <TableCell_noWrap align="center">
                アカウント
              </TableCell_noWrap>
            </TableRow>
          </TableHead>
          <TableBody>
            {!companies?.length ? (
              <TableRow>
                <TableCell colSpan={99} align="center">
                  {companies ? 'データは存在しないようです' : <Loading />}
                </TableCell>
              </TableRow>
            ) : (
              companies.map((v) => (
                <TableRow_clickable
                  key={v.companyId}
                  onClick={() => onSelectCompany(v)}
                  hover
                >
                  <TableCell_noWrap align="center">
                    {v.companyName}
                  </TableCell_noWrap>
                  <TableCell>
                    <Grid container spacing={1}>
                      {v.tags.map((vv, ii) => (
                        <Grid item key={ii}>
                          <Chip
                           label={vv.tagName} 
                           style={
                            isDark ?
                            {backgroundColor: 'gray'}
                            :
                            {backgroundColor: 'lightgray'}
                          }
                           />
                        </Grid>
                      ))}
                    </Grid>
                  </TableCell>
                  <TableCell align="center">{`${v.accounts} / ${
                    v.accountLimit || accountLimitDefault
                  }`}</TableCell>
                </TableRow_clickable>
              ))
            )}
          </TableBody>
        </Table_companyTable>
      </TableContainer>
      <Dialog
         open={modalOpen}
         onClose={() => setModalOpen(false)}
         fullWidth
         PaperProps={{ sx: { maxWidth: "revert", width: 650, height: 550 } }}
      >
        <form
           onSubmit={(e) => onEditCompany(e)}
           style={{width:'650px', height:'550px'}}
        >
          <DialogTitle>
            {'企業' + (company?.companyId ? '編集' : '追加')}
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  type="text"
                  label="企業名"
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                  style={{width:'600px',marginTop:'10px'}}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  type="number"
                  label="アカウント制限"
                  value={accountLimit}
                  onChange={(e) => setAccountLimit(parseInt(e.target.value))}
                 
                  style={{width:'185px',marginTop:'10px'}}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  select
                  name="recSec"
                  value={recSec}
                  onChange={(e) => setRecSec(parseInt(e.target.value))}
                  label="撮影時間"
                  style={{width:'185px',marginTop:'10px'}}
                >
                  {[60, 30].map((v) => (
                    <MenuItem key={v} value={v}>
                      {`${v} 秒`}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={4}>
                <TextField
                  select
                  name="recSec"
                  value={recCountPerDay}
                  onChange={(e) => setRecCountPerDay(parseInt(e.target.value))}
                  label="撮影回数"
                  style={{width:'185px',marginTop:'10px'}}
                >
                  {[1, 2, 3, 4, 5].map((v) => (
                    <MenuItem key={v} value={v}>
                      {`${v} 回 / 日`}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  type="text"
                  label="お知らせタイトル"
                  value={infoTitle}
                  onChange={(e) => setInfoTitle(e.target.value)}
                  style={{width:'600px',marginTop:'10px'}}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  type="text"
                  rows={6}
                  label="お知らせ"
                  placeholder="動画撮影中に表示するニューステキストを入力します。改行毎にリスト形式で表示されます"
                  value={infoText}
                  onChange={(e) => setInfoText(e.target.value)}
                  multiline
                  style={{width:'600px',marginTop:'10px'}}
                  inputProps={{
                    style: {
                      fontSize: 13,
                      lineHeight: 1.5,
                    },
                  }}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions
            style={{ marginRight: '1.0rem'}}
          >
            <Button
              type="submit"
              variant="contained"
              color="primary"
              startIcon={company ? <EditIcon /> : <AddIcon />}
            >
              {company ? '編集する' : '新規追加'}
            </Button>
            {!!company?.companyId && (
              <Button
                type="button"
                variant="contained"
                startIcon={<DeleteIcon />}
                onClick={() => setShowConfirm(true)}
              >
                削除を確認
              </Button>
            )}
          </DialogActions>
        </form>
      </Dialog>
      <Box
        position="absolute"
        right={0}
        bottom={theme.spacing(1)}
        display="flex"
      >
        <Fab color="secondary" onClick={() => setRefetch(refetch + 1)}>
          <RefreshIcon />
        </Fab>
        <Fab
          color="secondary"
          onClick={() => onSelectCompany()}
          style={{
            marginLeft: theme.spacing(1),
          }}
        >
          <AddIcon />
        </Fab>
      </Box>
      {showConfirm && (
        <ConfirmDialog
          onOk={onDeleteCompany}
          onCancel={() => setShowConfirm(false)}
          title={`企業「${company?.companyName}」の削除`}
          message="この操作は取り消せません。よろしいですか？"
        />
      )}
    </Box_page>
  );
};

const MemberEditModal = ({
  member,
  onClose,
  open,
  tags,
}: MentalTypes.MemberEditProps) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const { dispatch } = React.useContext(Context);
  const [nameFirst, setNameFirst] = React.useState(member?.nameFirst ?? '');
  const [nameLast, setNameLast] = React.useState(member?.nameLast ?? '');
  const [email, setEmail] = React.useState(member?.email ?? '');
  const [checkTags, setCheckTags] = React.useState<
    MentalTypes.MemberEditCheckTag[] | undefined
  >(
    tags?.map((tag) => {
      let flag: '' | 'user' | 'admin' = '';
      if (member?.tagIdsAdmin.includes(tag.tagId)) {
        flag = 'admin';
      } else if (member?.tagIds.includes(tag.tagId)) {
        flag = 'user';
      }
      return { ...tag, flag };
    })
  );
  const [showConfirm, setShowConfirm] = React.useState(false);
  const isAdd = !member;
  const [multiInput, setMultiInput] = React.useState(false);
  const [membersText, setMembersText] = React.useState('');
  const name = `${nameLast}${nameFirst}`;
  const onEdit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(dispatch, true);
    const members = [];
    if (multiInput) {
      membersText.split('\n').forEach((memberText) => {
        const memberTextArray = memberText.split(/,|\t/);
        if (memberText) {
          if (memberTextArray?.length !== 3) {
            showToast(
              dispatch,
              `"${membersText}" の行データがおかしいようです`
            );
            return;
          }
          members.push({
            userId: null,
            nameLast: memberTextArray[0],
            nameFirst: memberTextArray[1],
            email: memberTextArray[2],
          });
        }
      });
    } else {
      members.push({
        userId: member?.userId ?? null,
        email,
        nameFirst,
        nameLast,
      });
    }
    const tags_ =
      checkTags?.reduce<{ [tagId: string]: number }>((acc, cur) => {
        acc[cur.tagId] = cur.flag === '' ? 0 : cur.flag === 'user' ? 1 : 2;
        return acc;
      }, {}) ?? {};
    const res = await fbFunc('setUserData', {
      members,
      tags: tags_,
    });
    if (isErrFbFunc(dispatch, res, members.length > 1 ? 5 : 3)) {
      return;
    }
    setLoading(dispatch, false);
    const msgPrefix = isAdd ? '追加' : '編集';
    const msgMain = members.length === 1 ? name : 'メンバー';
    showToast(dispatch, `${msgMain}を${msgPrefix}しました`);
    onClose(true);
  };
  const onDelete = async () => {
    setLoading(dispatch, true);
    const res = await fbFunc('deleteUserData', { userId: member?.userId });
    setLoading(dispatch, false);
    if (isErrFbFunc(dispatch, res)) {
      return;
    }
    setShowConfirm(false);
    showToast(dispatch, `${name}を削除しました`);
    onClose(true);
  };
  const onCheckTag = (checkTag: MentalTypes.MemberEditCheckTag) => {
    checkTag.flag =
      checkTag.flag === '' ? 'user' : checkTag.flag === 'user' ? 'admin' : '';
    setCheckTags([...(checkTags ?? [])]);
  };
  return (
    <Dialog
       open={open}
       onClose={onClose}
       maxWidth={false}
       fullWidth
       PaperProps={
        multiInput ?
        { sx: { maxWidth: "revert", width: 700, height: 550 } }
        :
        { sx: { maxWidth: "revert", width: 700, height: 400 } }
      }
    >
       
      <form onSubmit={(e) => onEdit(e)}>
        <DialogTitle>
          {'メンバー' + (member?.userId ? '編集' : '追加')}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            {multiInput ? (
              <TextField
                type="text"
                rows={8}
                label="メンバーCSV"
                placeholder="姓,名,メールアドレス[改行]"
                value={membersText}
                onChange={(e) => setMembersText(e.target.value)}
                multiline
                fullWidth
                inputProps={{
                  style: {
                    fontSize: 13,
                    lineHeight: 1.5,
                  },
                }}
                style={{ marginLeft: '1.0rem', marginTop: '2.0rem'}}
              />
            ) : (
              <>
                <Grid item xs={6} sm={4}>
                  <TextField
                    type="text"
                    label="姓"
                    value={nameLast}
                    onChange={(e) => setNameLast(e.target.value)}
                    style={{ marginRight: '1.0rem', marginTop: '1.0rem'}}
                  />
                </Grid>
                <Grid item xs={6} sm={4}>
                  <TextField
                    type="text"
                    label="名"
                    value={nameFirst}
                    onChange={(e) => setNameFirst(e.target.value)}
                    style={{ marginRight: '1.0rem', marginTop: '1.0rem'}}
                  />
                </Grid>
                <Grid item xs={6} sm={4}>
                  <TextField
                    type="text"
                    label="メールアドレス"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    style={{ marginRight: '1.0rem', marginTop: '1.0rem'}}
                  />
                </Grid>
              </>
            )}
            <Box mt={1} style={{ marginLeft: '1.0rem', marginTop: '1.0rem'}}>
              <Grid item container spacing={1}>
                {checkTags?.map((checkTag) => (
                  <Grid item key={checkTag.tagId}>
                    <Chip
                      icon={checkTag.flag === '' ? undefined : <CheckIcon />}
                      onClick={() => onCheckTag(checkTag)}
                      label={
                        checkTag.companyName +
                        ' ＞ ' +
                        checkTag.tagName +
                        (checkTag.flag === 'admin' ? ' + 管理' : '')
                      }
                      style={
                        isDark ?
                        {backgroundColor: 'gray'}
                        :
                        {backgroundColor: 'lightgray'}
                      }
                    />
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Grid>
        </DialogContent>
        <DialogActions
          style={{ marginRight: '1.0rem'}}
        >
          {!member?.userId && (
            <Button
              type="button"
              variant="contained"
              onClick={() => setMultiInput(!multiInput)}
              startIcon={multiInput ? <PersonIcon /> : <PeopleIcon />}
            >
              {multiInput ? '単数入力' : '複数入力'}
            </Button>
          )}
          <Button
            type="submit"
            variant="contained"
            color="primary"
            startIcon={member?.userId ? <EditIcon /> : <AddIcon />}
          >
            {member?.userId ? '編集する' : '新規追加'}
          </Button>
          {!!member?.userId && (
            <Button
              type="button"
              variant="contained"
              onClick={() => setShowConfirm(true)}
              startIcon={<DeleteIcon />}
            >
              削除を確認
            </Button>
          )}
        </DialogActions>
      </form>
      {showConfirm && (
        <ConfirmDialog
          onOk={onDelete}
          onCancel={() => setShowConfirm(false)}
          title={`メンバー「${name}」の削除`}
          message="この操作は取り消せません。よろしいですか？"
        />
      )}
    </Dialog>
  );
};
const Members = () => {
  
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const { state } = React.useContext(Context);
  const { user } = state;
  const [member, setMember] = React.useState<
    MentalTypes.UserData | undefined
  >();
  const [members, setMembers] = React.useState<
    MentalTypes.UserData[] | undefined
  >();
  const [showMembers, setShowMember] = React.useState<
    MentalTypes.UserData[] | undefined
  >();
  const [showEditModal, setShowEditModal] = React.useState(false);
  const [showMeasureModal, setShowMeasureModal] = React.useState(false);
  const [search, setSearch] = React.useState('');
  const [tags, setTags] = React.useState<MentalTypes.Tag[] | undefined>();
  const [searchTags, setSearchTags] = React.useState<
    { [tagId: string]: boolean } | undefined
  >();
  const [measureDays, setMeasureDays] = React.useState(0);
  const [refetch, setRefetch] = React.useState(0);
  React.useEffect(() => {
    getTags(user?.tagIdsAdmin, user?.tagIdsAdmin).then((tags_) => {
      setTags(tags_);
      setSearchTags(
        tags_?.reduce<{ [key: string]: boolean }>((acc, cur) => {
          acc[cur.tagId] = true;
          return acc;
        }, {}) ?? {}
      );
    });
  }, [user]);
  React.useEffect(() => {
    if (user?.userId) {
      getMembersData(user?.tagIdsAdmin, measureDays).then((res) =>
        setMembers(res)
      );
    }
  }, [user, measureDays, refetch]);
  React.useEffect(() => {
    const showMembers_ = members?.filter((v) => {
      return (
        (v.nameFirst.indexOf(search) !== -1 ||
          v.nameLast.indexOf(search) !== -1 ||
          v.email.indexOf(search) !== -1) &&
        v.tagIds.some((tagId) => {
          return searchTags?.[tagId];
        })
      );
    });
    setShowMember(showMembers_);
  }, [search, searchTags, members]);
  const onClickMember = (member_: MentalTypes.UserData) => {
    setMember(member_);
    setShowMeasureModal(true);
  };
  const onClickAdd = () => {
    setMember(undefined);
    setShowEditModal(true);
  };
  const onClickMemberEdit = (
    e: React.MouseEvent<SVGSVGElement>,
    member_: MentalTypes.UserData
  ) => {
    e.stopPropagation();
    setMember(member_);
    setShowEditModal(true);
  };
  const onCloseMemberEdit = (update: boolean) => {
    setShowEditModal(false);
    if (update) {
      setRefetch(refetch + 1);
    }
  };
  const onClickTag = (tagId: string) => {
    setSearchTags({
      ...searchTags,
      [tagId]: searchTags?.[tagId] ? false : true,
    });
  };
  const onChangeMeasureType = (e: React.ChangeEvent<HTMLInputElement>) => {
    setMeasureDays(Number(e.target.value));
  };
  return (
    <Box_page>
      <Box
        display="flex"
        justifyContent="row"
        alignItems="center"
        flexWrap="wrap"
        style={{ position: 'relative' }}
      >
        <Box m={1}>
          <FormControl>
            <FormLabel>
              <Box_font12>結果の期間</Box_font12>
            </FormLabel>
            <RadioGroup
              row
              value={String(measureDays)}
              onChange={onChangeMeasureType}
            >
              <FormControlLabel
                value="0"
                control={<Radio />}
                label={<Typography>前回</Typography>}
              />
              <FormControlLabel
                value="7"
                control={<Radio />}
                label={<Typography>1 週間</Typography>}
              />
              <FormControlLabel
                value="30"
                control={<Radio />}
                label={<Typography>1 ヶ月</Typography>}
              />
            </RadioGroup>
          </FormControl>
        </Box>
        <Hidden smDown>
          <Box m={1}>
            <TextField
              type="text"
              label="姓名 / メールアドレス"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </Box>
          <Box>
            {tags?.map((t) => (
              <Chip
                key={t.tagId}
                size="small"
                icon={searchTags?.[t.tagId] ? <CheckIcon /> : undefined}
                onClick={() => onClickTag(t.tagId)}
                label={
                  <Box_font11>
                    {t.companyName.substring(0, 2) +
                      '｜' +
                      t.tagName.substring(0, 3)}
                  </Box_font11>
                }
                style={isDark ?
                  { margin: theme.spacing(1) ,backgroundColor: 'gray'}
                  :
                  { margin: theme.spacing(1) ,backgroundColor: 'lightgray'}
                }
              />
            ))}
          </Box>
        </Hidden>
      </Box>
      <TableContainer component={Paper} sx={{maxHeight: 'calc(100% - 80px)'}}>
        <Table_membersTable stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell_noWrap align="center">
                姓名
              </TableCell_noWrap>
              <TableCell_noWrap align="center">
                メールアドレス
              </TableCell_noWrap>
              <TableCell_noWrap align="center">
                タグ
              </TableCell_noWrap>
              <TableCell_noWrap align="center">
                結果
              </TableCell_noWrap>
              <TableCell_noWrap align="center">
                設定
              </TableCell_noWrap>
            </TableRow>
          </TableHead>
          <TableBody>
            {!showMembers?.length ? (
              <TableRow>
                <TableCell colSpan={99} align="center">
                  {showMembers ? '該当するデータはありません' : <Loading />}
                </TableCell>
              </TableRow>
            ) : (
              showMembers.map((v) => {
                return (
                  <TableRow_clickable
                    key={v.userId}
                    onClick={() => onClickMember(v)}
                    hover
                  >
                    <TableCell_noWrap align="center">
                      {v.nameLast + ' ' + v.nameFirst}
                    </TableCell_noWrap>
                    <TableCell_noWrap align="center">
                      {v.email}
                    </TableCell_noWrap>
                    <TableCell>
                      <Grid container spacing={1}>
                        {v.tagIds.map((tagId) => {
                          const tag = tags?.find(
                            (tag_) => tag_.tagId === tagId
                          );
                          if (!tag) {
                            return null;
                          }
                          return (
                            <Grid item key={tagId}>
                              <Chip_clickable
                                size="small"
                                label={
                                  <Box_font11>
                                    {tag?.companyName.substring(0, 2) +
                                      '｜' +
                                      tag?.tagName.substring(0, 3)}
                                  </Box_font11>
                                }
                                style={
                                  isDark ?
                                  {backgroundColor: 'gray'}
                                  :
                                  {backgroundColor: 'lightgray'}
                                }
                              />
                            </Grid>
                          );
                        })}
                      </Grid>
                    </TableCell>
                    <TableCell>
                      <Grid container spacing={1}>
                        {!v.measurement?.alerts.length ? (
                          <Grid item>
                            <Chip
                              size="small"
                              color={
                                !v.measurement?.createdAt
                                  ? 'default'
                                  : 'primary'
                              }
                              style={
                                !v.measurement?.createdAt ?
                                  isDark ?
                                  {backgroundColor: 'gray'}
                                  :
                                  {backgroundColor: 'lightgray'}
                                :
                                {}
                              }
                              label={
                                <Box_font11>
                                  {!v.measurement?.createdAt
                                    ? v.measurementShared === false
                                      ? '非公開'
                                      : '未実施'
                                    : '正常'}
                                </Box_font11>
                              }
                            />
                          </Grid>
                        ) : (
                          v.measurement.alerts.map((v) => (
                            <Grid item key={v}>
                              <Chip
                                size="small"
                                color="secondary"
                                label={
                                  <Box_font11>
                                    {chartLabelsName[v]}
                                  </Box_font11>
                                }
                              />
                            </Grid>
                          ))
                        )}
                        {!!v.measurement?.createdAt && (
                          <Grid item>
                            <Chip
                              size="small"
                              color="default"
                              label={
                                <Box_font11>
                                  {`${dayjs(
                                    v.measurement.createdAt.toDate()
                                  ).format('MM/DD')}｜更新`}
                                </Box_font11>
                              }
                              style={
                                isDark ?
                                {backgroundColor: 'gray'}
                                :
                                {backgroundColor: 'lightgray'}
                              }
                            />
                          </Grid>
                        )}
                      </Grid>
                    </TableCell>
                    <TableCell align="center">
                      <SettingsIcon
                        onClick={(e) => onClickMemberEdit(e, v)}
                        color="action"
                      />
                    </TableCell>
                  </TableRow_clickable>
                );
              })
            )}
          </TableBody>
        </Table_membersTable>
      </TableContainer>
      {showMeasureModal && (
        <MemberResultList
          open={showMeasureModal}
          onClose={() => setShowMeasureModal(false)}
          user={member}
        />
      )}
      {showEditModal && (
        <MemberEditModal
          open={showEditModal}
          onClose={onCloseMemberEdit}
          member={member}
          tags={tags}
        />
      )}
      <Box
        position="absolute"
        right={0}
        bottom={theme.spacing(1)}
        display="flex"
      >
        <Fab color="secondary" onClick={() => setRefetch(refetch + 1)}>
          <RefreshIcon />
        </Fab>
        <Fab
          color="secondary"
          onClick={onClickAdd}
          style={{
            marginLeft: theme.spacing(1),
          }}
        >
          <AddIcon />
        </Fab>
      </Box>
    </Box_page>
  );
};

const TagEditModal = ({
  tag,
  tags,
  onClose,
  open,
}: MentalTypes.TagEditProps) => {
  const { dispatch, state } = React.useContext(Context);
  const { user } = state;
  const companies = React.useMemo(
    () => tags?.filter((tag) => tag.tagName === '企業'),
    [tags]
  );
  const [tagName, setTagName] = React.useState(tag?.tagName ?? '');
  const [companyId, setCompanyId] = React.useState(
    tag?.companyId ?? companies?.[0].companyId
  );
  const [showConfirm, setShowConfirm] = React.useState(false);
  const isAdd = !tag;
  const onEdit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(dispatch, true);
    const res = await fbFunc('setTagData', {
      tagName,
      companyId,
      tagId: tag?.tagId,
    });
    setLoading(dispatch, false);
    if (isErrFbFunc(dispatch, res)) {
      return;
    }
    const msgSuffix = isAdd ? '追加' : '編集';
    showToast(dispatch, `${tagName} を${msgSuffix}しました`);
    getUserData(dispatch, user.userId).then(() => {
      onClose(true);
    });
  };
  const onDelete = async () => {
    setLoading(dispatch, true);
    const res = await fbFunc('deleteTagData', { tagId: tag?.tagId });
    setLoading(dispatch, false);
    if (isErrFbFunc(dispatch, res)) {
      return;
    }
    setShowConfirm(false);
    showToast(dispatch, `${tag?.tagName} を削除しました`);
    getUserData(dispatch, user.userId).then(() => {
      onClose(true);
    });
  };
  const onChangeCompanyId = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    setCompanyId(e.target.value);
  };
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      PaperProps={{ sx: { maxWidth: "revert", width: 500, height: 230 } }}
    >
      <form onSubmit={(e) => onEdit(e)}>
        <DialogTitle>{'タグ' + (tag?.tagId ? '編集' : '追加')}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item md={6}>
              <TextField
                select
                name="company"
                value={companyId}
                onChange={onChangeCompanyId}
                label="企業"
                style={{ marginRight: '1.0rem', marginTop: '1.0rem', width: '12.0rem' }}
              >
                {companies?.map((v) => (
                  <MenuItem key={v.companyId} value={v.companyId}>
                    {v.companyName}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item md={6}>
              <TextField
                type="text"
                label="タグ名"
                value={tagName}
                onChange={(e) => setTagName(e.target.value)}
                style={{ marginRight: '1.0rem', marginTop: '1.0rem', width: '12.0rem' }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions
          style={{ marginRight: '1.0rem'}}
        >
          <Button
            type="submit"
            variant="contained"
            color="primary"
            startIcon={isAdd ? <AddIcon /> : <EditIcon />}
          >
            {isAdd ? '新規追加' : '編集する'}
          </Button>
          {!isAdd && (
            <Button
              type="button"
              variant="contained"
              onClick={() => setShowConfirm(true)}
              startIcon={<DeleteIcon />}
            >
              削除を確認
            </Button>
          )}
        </DialogActions>
      </form>
      {showConfirm && (
        <ConfirmDialog
          onOk={onDelete}
          onCancel={() => setShowConfirm(false)}
          title={`タグ「${tag?.tagName}」の削除`}
          message="この操作は取り消せません。よろしいですか？"
        />
      )}
    </Dialog>
  );
};

const Tags = () => {
  
  const theme = useTheme();
  const { state } = React.useContext(Context);
  const { user } = state;
  const [tag, setTag] = React.useState<MentalTypes.Tag | undefined>();
  const [tags, setTags] = React.useState<MentalTypes.Tag[] | undefined>();
  const [refetch, setRefetch] = React.useState(0);
  const [showEditModal, setShowEditModal] = React.useState(false);
  React.useEffect(() => {
    if (user?.tagIdsAdmin) {
      getTags(user.tagIdsAdmin, user.tagIdsAdmin).then((tags_) =>
        setTags(tags_)
      );
    }
  }, [user?.tagIdsAdmin, refetch]);
  const onClickTag = (tag_?: MentalTypes.Tag) => {
    setTag(tag_);
    setShowEditModal(true);
  };
  const onClickRefresh = () => {
    setRefetch(refetch + 1);
  };
  const onCloseEdit = (update: boolean) => {
    setShowEditModal(false);
    if (update) {
      setRefetch(refetch + 1);
    }
  };
  return (
    <Box_page>
      <TableContainer component={Paper} sx={{maxHeight: 'calc(100% - 20px)'}}>
        <Table_tagsTable stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell align="center">企業</TableCell>
              <TableCell align="center">タグ</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!tags?.length ? (
              <TableRow>
                <TableCell colSpan={99} align="center">
                  {tags ? 'データは存在しないようです' : <Loading />}
                </TableCell>
              </TableRow>
            ) : (
              tags
                .filter((tag) => tag.tagName !== '企業')
                .map((v) => (
                  <TableRow_clickable
                    key={v.tagId}
                    onClick={() => onClickTag(v)}
                    hover
                  >
                    <TableCell>{v.companyName}</TableCell>
                    <TableCell>{v.tagName}</TableCell>
                  </TableRow_clickable>
                ))
            )}
          </TableBody>
        </Table_tagsTable>
      </TableContainer>
      <Box
        position="absolute"
        right={0}
        bottom={theme.spacing(1)}
        display="flex"
      >
        <Fab color="secondary" onClick={onClickRefresh}>
          <RefreshIcon />
        </Fab>
        <Fab
          color="secondary"
          onClick={() => onClickTag()}
          style={{
            marginLeft: theme.spacing(1),
          }}
        >
          <AddIcon />
        </Fab>
      </Box>
      {showEditModal && (
        <TagEditModal
          open={showEditModal}
          onClose={onCloseEdit}
          tag={tag}
          tags={tags}
        />
      )}
    </Box_page>
  );
};

const Home = () => {
  
  const { state } = React.useContext(Context);
  const { user } = state;
  const news = [
    {
      date: '2021/11/15',
      text: '存在ユーザーチェックの不具合修正',
    },
    {
      date: '2021/10/02',
      text: '内部構造改良｜企業タグを管理しやすいように',
    },
    {
      date: '2021/10/01',
      text: 'パフォーマンスチューニング',
    },
    {
      date: '2021/09/30',
      text: 'アカウントメニュー｜デフォルト企業設定を追加',
    },
    {
      date: '2021/09/24',
      text: '結果ファイルDL｜説明ダイアログを追加',
    },
    {
      date: '2021/09/04',
      text: '企業管理｜１日の撮影回数制限を設定可能に',
    },
    {
      date: '2021/09/03',
      text: '結果データの削除機能',
    },
    {
      date: '2021/09/02',
      text: '結果周波数グラフからXY軸ラベルを削除',
    },
    {
      date: '2021/09/02',
      text: '結果円グラフに標準領域を塗る',
    },
    {
      date: '2021/09/01',
      text: 'メンバー登録に複数入力機能を追加',
    },
    {
      date: '2021/08/30',
      text: 'メンバーの結果ファイルをDL出来るように',
    },
    {
      date: '2021/08/30',
      text: '一般ユーザーログイン時の権限チェックバグ修正',
    },
    {
      date: '2021/08/30',
      text: '公開フラグOFF時に結果の顔画像が表示されないバグ修正',
    },
    {
      date: '2021/08/30',
      text: '公開フラグOFF時にメンバーリスト上では自分の結果も見えなくする',
    },
    {
      date: '2021/08/30',
      text: '公開フラグOFF時に自分の結果も見えなくなるバグ修正',
    },
    {
      date: '2021/08/26',
      text: '診断結果の表示でユーザー側の公開フラグを見るように',
    },
    {
      date: '2021/08/20',
      text: 'パスワード設定機能の追加',
    },
    {
      date: '2021/08/18',
      text: 'メール＆パスワードでログイン機能の追加',
    },
    {
      date: '2021/08/17',
      text: 'データ削除時の UI 変更｜ダイアログで確認するように',
    },
    {
      date: '2021/08/17',
      text: 'ログイン時・データ更新時など時間がかかる処理でのローディング演出追加',
    },
    {
      date: '2021/08/13',
      text: '各種データ｜リロードボタン追加',
    },
    {
      date: '2021/08/10',
      text: 'コードリファクタリング｜ローディング処理改善',
    },
    {
      date: '2021/08/10',
      text: '診断結果＞無限スクロール｜期間絞込み｜期間集計',
    },
    {
      date: '2021/07/26',
      text: 'ダークモード設定をローカルストレージに保存',
    },
    {
      date: '2021/07/26',
      text: '部下の診断結果＞上司向けの評価コメントに変更',
    },
    {
      date: '2021/07/22',
      text: '診断結果＞レイアウト修正、顔画像表示、比較機能改良 ( 直近３ヶ月自由選択 )、配下ユーザー結果にも適用',
    },
    {
      date: '2021/07/11',
      text: 'フォントサイズ調整｜アプリサイズ軽量化',
    },
    {
      date: '2021/07/08',
      text: '全面 Material-UI で書き直し完了',
    },
    {
      date: '2021/05/31',
      text: 'クライアント要望( 5/24 )に対応',
    },
    {
      date: '2021/05/25',
      text: 'メンタルチェック中にニュース表示',
    },
    {
      date: '2021/05/18',
      text: '企業管理｜チェック中ニュース登録',
    },
    {
      date: '2021/05/18',
      text: '企業管理｜アカウント数制限',
    },
    {
      date: '2021/05/08',
      text: '診断結果｜結果エクセル他ファイルダウロード機能追加',
    },
    {
      date: '2021/05/07',
      text: '結果｜別日比較機能追加',
    },
    {
      date: '2021/05/06',
      text: 'メンバー｜結果検索',
    },
    {
      date: '2021/05/06',
      text: 'デザイン変更',
    },
    {
      date: '2021/05/06',
      text: 'メンバー｜結果表示',
    },
    {
      date: '2021/05/05',
      text: 'メンバー｜検索機能',
    },
    {
      date: '2021/05/01',
      text: 'ウェブでチェック＆結果表示',
    },
    {
      date: '2021/04/20',
      text: 'パフォーマンス改善２',
    },
    {
      date: '2021/04/15',
      text: 'パフォーマンス改善１',
    },
    {
      date: '2021/04/04',
      text: 'セキュリティ対応｜基盤設計の修正',
    },
    {
      date: '2021/03/28',
      text: 'デザイン修正',
    },
    {
      date: '2021/03/18',
      text: '管理システムデモ版',
    },
  ];
  return (
    <Box_page>
      <TableContainer component={Paper} sx={{maxHeight: 'calc(100% - 80px)'}}>
        <Table_homeTable stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell align="center">日付</TableCell>
              <TableCell align="center">更新内容</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!user.nameFirst || user.nameFirst === 'ゲスト' ? (
              <TableRow>
                <TableCell colSpan={99} align="center">
                  {user.nameFirst === 'ゲスト' ? (
                    'ログインしてください'
                  ) : (
                    <Loading />
                  )}
                </TableCell>
              </TableRow>
            ) : (
              news.map((v, i) => (
                <TableRow key={i}>
                  <TableCell>{v.date}</TableCell>
                  <TableCell>{v.text}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table_homeTable>
      </TableContainer>
    </Box_page>
  );
};

const App = (): JSX.Element => {
  
  const [state, dispatch] = React.useReducer(reducer, initialState);
  const { user, auth, toast, loader } = state;
  const [signInView, setSignInView] = React.useState(false);
  const [signOutView, setSignOutView] = React.useState(false);
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [darkMode, setDarkMode] = React.useState(
    getLocalStorageItem('darkMode') !== 'false'
  );
  const [showConfirm, setShowConfirm] = React.useState(false);
  const [mode, setMode] = React.useState(0); 

  const signButtonRef = React.useRef<HTMLDivElement>(null);
  React.useEffect(() => {
    
      if (auth?.uid) {
        getUserData(dispatch, auth.uid);
        // if(auth?.emailVerified){
        //   getUserData(dispatch, auth.uid);
        // }else{
          
        //   setShowConfirm(true);
        //   // signOut(firebaseAuth)
        //   // .then(() => {
            
        //   // })
        //   // .catch((error) => {
        //   //   console.log(error, 'error');
        //   // });
        //   dispatch({
        //     type: 'USER_UPDATE',
        //     payload: {
        //       ...initialState.user,
        //       nameFirst: 'ゲスト',
        //     },
        //   });
          
        // }
      } else if (auth) {
        dispatch({
          type: 'USER_UPDATE',
          payload: {
            ...initialState.user,
            nameFirst: 'ゲスト',
          },
        });
      }

  }, [auth]);
  React.useEffect(() => {
    return onAuthStateChanged(firebaseAuth, (user_) => {
      dispatch({ type: 'AUTH_UPDATE', payload: user_ || {} });
    });
  }, []);
  React.useEffect(() => {
    if (isSignInWithEmailLink(firebaseAuth, window.location.href)) {
      setLoading(dispatch, true);
      const email = getLocalStorageItem('emailForSignIn');
      signInWithEmailLink(firebaseAuth, email ?? '', window.location.href)
        .then(() => {
          showToast(dispatch, 'ログインしました').then(() => {
            history.replaceState('', '', '/');
          });
        })
        .catch((e) => {
          showToast(dispatch, 'ログインに失敗しました');
          console.log(e.message);
        })
        .finally(() => {
          setLoading(dispatch, false);
        });
    }
  }, []);
  const onChangeDark = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDarkMode(e.target.checked);
    setLocalStorageItem('darkMode', e.target.checked ? 'true' : 'false');
  };
  const onClickSnackbar = () => {
    dispatch({
      type: 'TOAST_UPDATE',
      payload: { ...toast, open: false },
    });
  };
  const themeValues_ = { ...themeValues };
  if (themeValues_.palette?.mode) {
    if (darkMode) {
      themeValues_.palette.mode = 'dark';
    } else {
      themeValues_.palette.mode = 'light';
    }
  }

  const onSendMail = () => {
      if(auth){
        sendEmailVerification(auth).then(() =>{

        })
        .catch((e) => {
          showToast(dispatch, 'メール送信でエラーが発生しました。お手数ですが時間を空けて再度お試しください。');
          console.log(e.message);
        })
        .finally(() => {
          setShowConfirm(false)
        })

      }

  };

  
  React.useEffect(() => {
    getMaintenance().then((res) => {
      
    });
  },[]);


  // const CustomRoute = ({
  //   beforeEnter,
  //   redirectPath,
  //   ...props
  // }: MentalTypes.CustomRouteProps) => {
  //   const beforeEnterResult = beforeEnter();

  //   return beforeEnterResult ? <Outlet/> : <Navigate to={redirectPath}/>
  // };

  return (
    <Context.Provider value={{ state, dispatch }}>
      <ThemeProvider theme={createTheme(themeValues_)}>
        <CssBaseline />
        <Container_container maxWidth="xl" style={{width: '1280px'}}>
          <Router>
            <AppBar_headerAppBar position="static">
              <Toolbar>
                <Hidden mdUp>
                  <IconButton
                    color="inherit"
                    onClick={() => setOpenDrawer(true)}
                  >
                    <MenuIcon />
                  </IconButton>
                  <Box flexGrow={1} />
                </Hidden>
                <Link_headerLogo
                  to="/"
                  onClick={() => setMode(0)}
                >
                  <Typography variant="h4">スマイルエス</Typography>
                </Link_headerLogo>
                <Box flexGrow={1} />
                <Hidden smDown>
                  {NavLinks.map((v) => {
                    const IconComponent = v.icon;
                    if (!v.always && !user.userId) {
                      return;
                    }
                    return (
                      <Link_headerNavLink
                        key={v.link}
                        //activeClassName={classes.headerNavLinkActive}
                        to={v.link}
                        //exact={v.exact ?? false}
                        style={ mode === v.mode ?
                           {opacity:1.0} 
                           :
                           {}
                        }
                        onClick={() => setMode(v.mode)}
                      >
                        <IconComponent 
                          
                        />
                        <Box fontSize="small">{v.name}</Box>
                      </Link_headerNavLink>
                    );
                  })}
                </Hidden>
                <Box_div
                  component="div"
                  style={{ opacity: 1 }}
                  onClick={() =>
                    user?.userId ? setSignOutView(true) : setSignInView(true)
                  }
                  ref={signButtonRef}
                >
                  <AccountCircleIcon />
                  <Box fontSize="small">
                    {user?.userId
                      ? user?.nameLast + user?.nameFirst
                      : 'ログイン'}
                  </Box>
                </Box_div>
                <Hidden smDown>
                  <Box ml={2}>
                    <FormGroup row>
                      <FormControlLabel
                        control={
                          <MuiSwitch
                            checked={darkMode}
                            onChange={onChangeDark}
                            name="darkMode"
                            color="default"
                          />
                        }
                        label={darkMode ? 'Dark' : 'Light'}
                      />
                    </FormGroup>
                  </Box>
                </Hidden>
                {signOutView && (
                  <SignOutView
                    open={signOutView}
                    onClose={() => setSignOutView(false)}
                    anchorEl={signButtonRef.current}
                  />
                )}
                {signInView && (
                  <SignInView
                    open={signInView}
                    onClose={() => setSignInView(false)}
                    anchorEl={signButtonRef.current}
                  />
                )}
              </Toolbar>
            </AppBar_headerAppBar>
            <Box_containerRoute p={2}>
              <Routes>
                <Route path="/" element = {<Home />}/>
                <Route path="/results" element = {<ResultList />}/>
                <Route path="/company" element = {<Company />}/>
                <Route path="/members" element = {<Members />}/>
                <Route path="/tags" element = {<Tags />}/>
                <Route path="/maintenance" element = {<Maintenance />}/>
              </Routes>
            </Box_containerRoute>
            <Drawer
              anchor="left"
              open={openDrawer}
              onClose={() => setOpenDrawer(false)}
            >
              <List>
                {NavLinks.map((v) => {
                  const IconComponent = v.icon;
                  if (!v.always && !user.userId) {
                    return;
                  }
                  return (
                    <Link_headerNavLink
                      key={v.link}
                      //activeClassName={classes.headerNavLinkActive}
                      to={v.link}
                      //exact={v.exact ?? false}
                      style={{
                        color: darkMode ? '#fff' : '#000',
                      }}
                    >
                      <ListItem button onClick={() => setOpenDrawer(false)}>
                        <ListItemIcon>
                          <IconComponent />
                        </ListItemIcon>
                        <ListItemText primary={v.name} />
                      </ListItem>
                    </Link_headerNavLink>
                  );
                })}
              </List>
              <Box px={2}>
                <FormGroup row>
                  <FormControlLabel
                    control={
                      <MuiSwitch
                        checked={darkMode}
                        onChange={onChangeDark}
                        name="darkMode"
                        color="default"
                      />
                    }
                    label={darkMode ? 'Dark' : 'Light'}
                  />
                </FormGroup>
              </Box>
            </Drawer>
          </Router>
          <Snackbar_clickable
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
            open={toast.open}
            onClick={onClickSnackbar}
          >
            <div>
            <Alert severity={toast.severity}>
              {Array.isArray(toast.message) ? (
                toast.message.map((message: string, i: number) => (
                  <div key={i}>{message}</div>
                ))
              ) : (
                <div>{toast.message}</div>
              )}
            </Alert>
            </div>
          </Snackbar_clickable>
          {showConfirm && (
            <ConfirmDialog
              onOk={onSendMail}
              onCancel={() => setShowConfirm(false)}
              title={`メールの認証が完了していません！`}
              message="認証メールの再送信を行いますか？決定を押すとメールが送信されます。"
            />
          )}
          <Backdrop_loader
            open={loader}
            onClick={() => setLoading(dispatch, false)}
          >
            <CircularProgress color="inherit" />
          </Backdrop_loader>
        </Container_container>
      </ThemeProvider>
    </Context.Provider>
  );
};

export default App;
